
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import Select from 'react-select';
import load from "../../../assets/Images/loader.gif";
import * as api from "../../../api_function";
// import BusinessOppotunitySurveyForm from './BusinessOppotunitySurveyForm';
import * as wifiOptions from "../../../options_sets/WifiOptions"
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import { cache } from 'react';
import { Dropdown } from 'bootstrap';
import { components as RSComponents } from 'react-select'

const password = sessionStorage.getItem('password');
const userName = sessionStorage.getItem('userName');

const optionSpecialFloor = [
    { label: "Select Special Floor", value: "" },
    { label: "Ground Floor", value: "111260000" },
    { label: "Basement 1", value: "111260001" },
    { label: "Basement 2", value: "111260002" },
    { label: "Basement 3", value: "111260003" },
];

const optionContactFor = [
    { label: "Office", value: "2" },
    { label: "SOHO", value: "4" },
    { label: "Business Value", value: "5" },
]

const painPointOptions = [
    // { value: "poorCustomerReviews", label: "Poor Customer Reviews" },
    // { value: "tenantComplaints", label: "Tenant Complaints" },
    // { value: "tenantChurn", label: "Tenant Churn" },
    // { value: "poorCustomerSupport", label: "Poor Customer Support from existing vendor" },
    // { value: "multipleVendors", label: "Multiple Vendors" },
    // { value: "newBuilding", label: "New Building" },

    { value: "FrequentDowntime", label: "Frequent Downtime" },
    { value: "SpeedPerformance", label: "Speed Performance" },
    { value: "HighLatency", label: "High Latency" },
    { value: "BillingDiscrepancies", label: "Billing Discrepancies" },
    { value: "PoorServiceSupportSLAViolations", label: "Poor Service Support / SLA Violations" },
    { value: "LimitedScalabilityUpgradeChallenges", label: "Limited Scalability / Upgrade Challenges" },
    { value: "SecurityConcernsComplianceIssues", label: "Security Concerns / Compliance Issues" },
    { value: "BadCoverageInfrastructureLimitations", label: "Bad Coverage / Infrastructure Limitations" },
    { value: "NoRedundancybackuplink", label: "No Redundancy / Backup Link" },
    { value: "NoMonitoringUsageReport", label: "No Monitoring / Usage Report" },
]

const optionSolutation = [
    { label: "Select Salutation", value: "0" },
    { label: "Mr.", value: "1" },
    { label: "Mrs.", value: "2" },
    { label: "Miss", value: "3" },
];

const quoteStatusOptions = [
    { label: "Draft", value: "0" },
    { label: "Active.", value: "1" },
    { label: "Won.", value: "2" },
    { label: "Close", value: "3" },
];

const optionTurnOver = [
    { label: "Select Option", value: "0" },
    { label: "Diamond (>250Cr)", value: "111260000" },
    { label: "Emerald (100Cr-250Cr)", value: "111260001" },
    { label: "Ruby (10Cr-100Cr)", value: "111260002" },
    { label: "Bronze (1Cr-10Cr)", value: "111260003" }
]

const optionCountry = [{ label: "India", value: "10001" }];

const optionState = [
    { name: "Select State", code: "" },
    { name: "Andhra Pradesh", code: "100009" },
    { name: "Jharkhand", code: "100030" },
    { name: "Bihar", code: "100021" },
    { name: "Delhi", code: "100004" },
    { name: "Gujarat", code: "100015" },
    { name: "Haryana", code: "100008" },
    { name: "Jammu and Kashmir", code: "100011" },
    { name: "Karnataka", code: "100007" },
    { name: "Kerala", code: "100012" },
    { name: "Madhya Pradesh", code: "100014" },
    { name: "Maharashtra", code: "100002" },
    { name: "Odisha", code: "100026" },
    { name: "Other*", code: "100017" },
    { name: "Punjab", code: "100025" },
    { name: "Rajasthan", code: "100010" },
    { name: "Tamil Nadu", code: "100003" },
    { name: "Telangana", code: "100023" },
    { name: "Uttar Pradesh", code: "100006" },
    { name: "Uttarakhand", code: "100016" },
    { name: "West Bengal", code: "100013" },
    { name: "Goa", code: "100028" },
];

const optionCustomerSeg = [
    { label: "Select Customer Segment", value: "0" },
    { label: "SDWAN", value: "111260004" },
    { label: "SMB", value: "111260000" },
    { label: "Media", value: "111260001" },
    { label: "LA", value: "111260002" },
    { label: "SP", value: "111260003" },
];

const firmtype = [
    { value: "0", label: "Select Firm Type" },
    { value: "1", label: "Proprietorship" },
    { value: "2", label: "Partnership" },
    { value: "3", label: "Pvt Ltd" },
    { value: "4", label: "Ltd" },
    { value: "5", label: "Trust" },
    { value: "6", label: "Individual" },
    { value: "7", label: "LLP" },
];

const media = [
    { label: "Fibre", value: "1" },
    { label: "RF", value: "2" },
]

const ExServiceProvider = [
    { label: "Select Service Provider 1", value: "0" },
    { label: "Jio", value: "111260000" },
    { label: "ACT Fibernet", value: "569480014" },
    { label: "N.A", value: "569480012" },
    { label: "Others", value: "569480013" },
    { label: "Airtel", value: "569480000" },
    { label: "Aircel", value: "569480002" },
    { label: "BSNL", value: "569480003" },
    { label: "Hathway", value: "569480004" },
    { label: "MTNL", value: "569480005" },
    { label: "Nextra", value: "569480006" },
    { label: "Reliance Communications", value: "569480007" },
    { label: "Sify", value: "569480008" },
    { label: "Tata Communications", value: "569480009" },
    { label: "Tata DOCOMO", value: "569480010" },
    { label: "Tikona Infinet", value: "569480011" },
    { label: "Vodafone", value: "569480001" },
]

const optionInterestedFirewall = [
    { label: "Select Option", value: "" },
    { label: "Yes", value: "1" },
    { label: "No", value: "2" }
];

const optionInterestedVPN = [
    { label: "Select Option", value: "" },
    { label: "Yes", value: true },
    { label: "No", value: false }
];

const optionInterestedManageWiFi = [
    { label: "Select Option", value: "" },
    { label: "Yes", value: "1" },
    { label: "No", value: "2" }
];



const userTypeOption = [

    { value: "111260000", label: "Base Plan" },
    { value: "111260001", label: "User 2" },
    { value: "111260002", label: "User 3" },
    { value: "111260003", label: "User 4" },
    { value: "111260004", label: "Visitor" },
    { value: "111260005", label: "Event" },
];

const speedPerUserOption = [

    { value: "111260000", label: "Upto 5 Mbps" },
    { value: "111260001", label: "Upto 10 Mbps" },
    { value: "111260002", label: "Upto 15 Mbps" },
    { value: "111260003", label: "Upto 20 Mbps" },
    { value: "111260004", label: "Upto 30 Mbps" },
    { value: "111260005", label: "Upto 40 Mbps" },
    { value: "111260006", label: "Upto 50 Mbps" },
    { value: "111260007", label: "Upto 75 Mbps" },
    { value: "111260008", label: "Upto 100 Mbps" },
];

const planValidityOption = [

    { value: "111260000", label: "Per Day" },
    { value: "111260001", label: "Per Month" },
];

const loginMechanismOption = [
    { value: "111260000", label: "Username & Password" },
    { value: "111260001", label: "Username & Password with Additional Authentication" },
    { value: "111260002", label: "RMN & One-Time Password(OTP)" },
    { value: "111260003", label: "MAC Authentication" },
];


const BusinessProWifiOpp = () => {
    const style = {
        control: (base) => ({
            ...base,
            border: 0,
            // Remove box shadow
            boxShadow: "none",
            backgroundColor: "transparent",
            color: "black",
        }),
    };



    const [showForm, setShowForm] = useState(false)
    const [selectedReasons, setSelectedReasons] = useState([])

    const [officeEmployeeCount, setOfficeEmployeeCount] = useState(false);
    const [coverageAreaRange, setCoverageAreaRange] = useState(false);
    const [accessPointsCount, setAccessPointsCount] = useState(false);
    const [planName, setPlanName] = useState(false);

    const [meetingcounter, setmeetingcounter] = useState("");
    const [allPraposalData, setAllPraposalData] = useState([]);
    const [userType, setUserType] = useState("");
    const [speedPerUser, setSpeedPerUser] = useState("");
    const [planValidity, setPlanValidity] = useState("");
    const [loginMechanism, setLoginMechanism] = useState("");

    const [activeForm, setActiveForm] = useState("form1");
    const [loading, setLoading] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState("");
    const [selectedRelatedProduct, setSelectedRelatedProduct] = useState("");
    const [discountFlag, setDiscountFlag] = useState();
    const [getExOtcDiscount, setExOtcDiscount] = useState("NA");
    const [getExRcDiscount, setExRcDiscount] = useState("NA");
    const [productOptions, setProductOptions] = useState([]);
    const [relatedProductOptions, setRelatedProductOptions] = useState([]);
    const [getOTCProd, setOTCProd] = useState([]);
    const [getRCProd, setRCProd] = useState([]);
    const [selectedPriceList, setSelectedPriceList] = useState("");
    const [priceListOptions, setPriceListOptions] = useState([]);
    const [leadid, setleadid] = useState("");
    const [industrydropdetails, setindustrydropdetails] = useState([]);
    const [selectSociety, setSelectSociety] = useState("");
    const [selectedFirmType, setSelectedFirmType] = useState();
    const [selectIndustry, setSelectIndustry] = useState();
    const [selectedCompany, setSelectedCompany] = useState();
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [enableGenerateFeasibilityBtn, setEnableGenerateFeasibilityBtn] = useState(false);
    const [isRedundancyLocked, setIsRedundancyLocked] = useState(false);
    const [selectGroup, setSelectGroup] = useState("");
    const [selectRelationship, setSelectRelationship] = useState({});
    const [loader, setLoader] = useState(false);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [getOtcDiscount, setOtcDiscount] = useState([]);
    const [getRcDiscount, setRcDiscount] = useState([]);
    const [groupOptions, setGroupOptions] = useState([]);
    const [relationshipOptions, setRelationOptions] = useState([]);
    const [selectSolutaton, setSelectSolutaton] = useState(optionSolutation[0]);
    const [statusCode, setStatusCode] = useState("")
    const [status, setStatus] = useState("")
    const [selectCountry, setSelectCountry] = useState("");
    const [selectState, setSelectState] = useState("");
    const [selectCity, setSelectCity] = useState("");
    const [cityType, setCityType] = useState([]);
    const [areaList, setAreaList] = useState([]);
    const [selectArea, setSelectArea] = useState("");
    const [buildingList, setBuildingList] = useState([]);
    const [selectBuilding, setSelectBuilding] = useState("");
    const [selectCustomerSeg, setSelectCustomerSeg] = useState(optionCustomerSeg[0]);
    const [selectTurnOver, setSelectTurnOver] = useState(optionTurnOver[0]);
    const [selectedMedia, setSelectedMedia] = useState(optionTurnOver[0]);
    const [selectExServiceProvider1, setSelectExServiceProvider1] = useState();
    const [selectInterestedFirewall, setSelectInterestedFirewall] = useState('');
    const [selectInterestedVPN, setSelectInteretedVPN] = useState();
    const [selectInterestedManageWiFi, setSelectInterestedManageWiFi] = useState('');
    const [otcAmount, setOtcAmount] = useState("")
    const [rcAmount, setRcAmount] = useState("")
    const [sdAmount, setSdAmount] = useState("")
    const [otcAmountDis, setOtcAmountDis] = useState("")
    const [rcAmountDis, setRcAmountDis] = useState("")
    const [getDoaApprovalData, setDoaApprovalData] = useState([]);
    const [getDoaApprovedFlag, setDoaApprovedFlag] = useState(true);
    const [getFeasibilityApprovedFlag, setFeasibilityApprovedFlag] = useState(true);
    const [getSurveyApprovedFlag, setSurveyApprovedFlag] = useState(true);
    const [getFeasibilityData, setFeasibilityData] = useState([]);
    const [getSurveyTaskData, setSurveyTaskData] = useState([]);
    const [getPreSalesTask, setPreSalesTask] = useState([]);
    const [getSurveyTask, setSurveyTask] = useState([]);
    const [getQuoteDetail, setQuoteDetail] = useState([]);
    const [getCompanyGroupList, setCompanyGroupList] = useState([]);
    const [getUserlicencegridData, setUserlicencegridData] = useState([]);
    const [allQuoteData, setAllQuoteData] = useState([]);
    const [proposalOptionType, setProposalOptionType] = useState("");


    const redirectPriceCalPage = () => {
        const area = Number(totalCarpetArea);
        const employees = Number(totalEmpCount);

        const isAreaValid = area >= 600 && area <= 4500;
        const isEmployeeValid = employees >= 30 && employees <= 100;


        if (!selectDoesCustNeedStaticIP?.value) {
            toast.warning("Select does customer need static IP", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }

        if (!isNaN(employees) && !isNaN(area)) {
            // Profi SoHo: Users 1-29, Area 1-599 Sq.Ft
            if ((employees >= 1 && employees <= 29) && (selectDoesCustNeedStaticIP?.value == "111260001")) {
                if ((area < 1 || area > 599) && (selectDoesCustNeedStaticIP?.value == "111260001")) {
                    toast.warning(
                        "For 1-29 users, Office Sitting Area (sqft) must be between 1 and 599.",
                        { position: toast.POSITION.BOTTOM_CENTER, autoClose: 3500 }
                    );
                    setTotalCarpetArea("");
                    return;
                }
            }
            // Profi Office: Users 30-100, Area 600-4500 Sq.Ft
            else if ((employees >= 30 && employees <= 100) && (selectDoesCustNeedStaticIP?.value == "111260001")) {
                if ((area < 600 || area > 4500) && (selectDoesCustNeedStaticIP?.value == "111260001")) {
                    toast.warning(
                        "For 30-100 users, Office Sitting Area (sqft) must be between 600 and 4500.",
                        { position: toast.POSITION.BOTTOM_CENTER, autoClose: 3500 }
                    );
                    setTotalCarpetArea("");
                    return;
                }
            }
            // Users outside the valid range
            else if ((employees < 1 || employees > 100)) {
                toast.warning(
                    "Internet Users (count) must be between 1 and 100.",
                    { position: toast.POSITION.BOTTOM_CENTER, autoClose: 3500 }
                );
                setTotalEmpCount("");
                return;
            }
        }

        if (selectContactFor.value == "2" || selectContactFor.value == "5") {
            if (!noOfUnit || noOfUnit == 0) {
                toast.warning("Number of Unit must be selected", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 2000,
                }
                );
                return;
            }

            if (!isAreaValid && selectDoesCustNeedStaticIP?.value == "111260001") {
                toast.warning("Office area must be between 600 and 4500 sq.ft", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 2000,
                }
                );
                return;
            }
            if (!isEmployeeValid && selectDoesCustNeedStaticIP?.value == "111260001") {
                toast.warning("Employee count must be between 30 and 100", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 2000,
                }
                );
                return;
            }
        }

        if (opportunityData?.Status?.toLowerCase() === "won") {
            Swal.fire({
                icon: "warning",
                html: '<div style="font-size: 14px;">This opportunity is already marked as <b>Won</b> and cannot be edited.</div>',
                confirmButtonText:
                    '<span style="font-size: 14px;color:rgb(148,101,170);">OK</span>',
                confirmButtonColor: "white",
                customClass: {
                    popup: "custom-popup",
                    confirmButton: "custom-confirm-button",
                },
            });
            return; // prevent further execution
        }
        if (opportunityData?.Status?.toLowerCase() === "lost") {
            Swal.fire({
                icon: "warning",
                html: '<div style="font-size: 14px;">This opportunity is already marked as <b>Lost</b> and cannot be edited.</div>',
                confirmButtonText:
                    '<span style="font-size: 14px;color:rgb(148,101,170);">OK</span>',
                confirmButtonColor: "white",
                customClass: {
                    popup: "custom-popup",
                    confirmButton: "custom-confirm-button",
                },
            });
            return; // prevent further execution
        }
        Swal.fire({
            html: '<div style="font-size: 14px;">Unsaved changes will be lost. Do you want to proceed?</div>',
            showCancelButton: true,
            confirmButtonText:
                '<span style="font-size: 14px;color:rgb(148,101,170);">YES</span>',
            cancelButtonText:
                '<span style="font-size: 14px;color:rgb(148,101,170);">NO</span>',
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            customClass: {
                popup: "custom-popup",
                confirmButton: "custom-confirm-button",
                cancelButton: "custom-cancel-button",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                // navigate(`/addProductProWifi?OppId=${OppId}`);
                if ((selectContactFor?.value == "2" || selectContactFor?.value == "5") && (selectDoesCustNeedStaticIP.value == "111260000" || !selectDoesCustNeedStaticIP || selectDoesCustNeedStaticIP.value == "111260001")) {
                    navigate(`/selectProductProwifi?OppId=${OppId}`);
                } else if (selectContactFor?.value == "4" && (selectDoesCustNeedStaticIP.value == "111260001" || !selectDoesCustNeedStaticIP)) {
                    navigate(`/selectProductSOHO?OppId=${OppId}`);
                }
                // else if (selectContactFor?.value == "5" && selectDoesCustNeedStaticIP.value == "111260000") {
                //     navigate(`/selectProductBusinessValue?OppId=${OppId}`);
                //     //    navigate(`/selectProductProwifi?OppId=${OppId}`);
                // }
                // navigate(`/selectProductProwifi?OppId=${OppId}`);
            }
        });
    }


    const [totalFloors, setTotalFloors] = useState("");
    const [commonArea, setCommonArea] = useState(null);
    const [elevator, setElevator] = useState(null);
    const [existingConnectivity, setExistingConnectivity] = useState(null);
    const [barriers, setBarriers] = useState(null);
    const [officeArea, setOfficeArea] = useState(null);
    const [applications, setApplications] = useState(null);

    const [companyTurnover, setCompanyTurnover] = useState(null);

    // For multi-select, we keep the selected options
    const [selectedFloors, setSelectedFloors] = useState([]);
    const pgTypeOptions = [
        { value: "111260000", label: "Men" },
        { value: "111260001", label: "Women" },
        { value: "111260002", label: "Hybrid" },
    ];

    const tenantTypeOptions = [
        { value: "111260000", label: "Professional" },
        { value: "111260001", label: "Student" },
    ];

    const contactDesignationOptions = [
        // { value: "111260000", label: "Owner" },
        // { value: "111260001", label: "Manager" },
        // { value: "111260002", label: "CareTaker" },
        // { value: "111260003", label: "Other" },

        { label: "Select Option", value: "0" },
        { label: "Admin Manager", value: "111260004" },
        { label: "IT / Network Manager", value: "111260005" },
        { label: "Other", value: "111260003" },
    ]


    const roleOptions = [
        { value: "111260000", label: "KDM" },
        { value: "111260001", label: "Influencer" },
    ];

    const existingInternetProviderOptions = [
        { value: "111260000", label: "Airtel" },
        { value: "111260001", label: "Jio" },
        { value: "111260002", label: "Tata" },
        { value: "111260003", label: "ACT" },
        { value: "111260004", label: "New Building" },
        { value: "111260005", label: "Others" },
    ];

    const existingInternetOutflowOptions = [
        { value: "111260000", label: "<5000" },
        { value: "111260001", label: "5001 - 10000" },
        { value: "111260008", label: "10001 - 20000" },
        { value: "111260009", label: ">20,000" },
        // { value: "111260002", label: "10001- 15000" },
        // { value: "111260003", label: "15001 - 20000" },
        // { value: "111260004", label: "20001 - 25000" },

        // { value: "111260005", label: ">25000" },
        { value: "111260006", label: "New Building" },
        { value: "111260007", label: "Others" },
    ];

    const urgentTriggersOptions = [
        { value: "111260000", label: "New semester" },
        { value: "111260001", label: "Tenant move-ins" },
        { value: "111260002", label: "Infrastructure Upgrades" },
        { value: "111260003", label: "Expiry of Existing Service Provider" },
        { value: "111260004", label: "New Building" },
    ];

    const spectraRelationshipOptions = [
        { value: "111260000", label: "Existing User" },
        { value: "111260001", label: "Past User" },
        { value: "111260002", label: "New" },
    ];
    const currentInfraOptions = [
        { value: "111260000", label: "Broadband" },
        { value: "111260001", label: "Access Points" },
        { value: "111260002", label: "Others" },
    ];

    // Initial floor coverage state: default is "111260001" (No) for every floor
    const initialFloorCoverage = {
        Basement: "111260001",
        Ground: "111260001",
        First: "111260001",
        Second: "111260001",
        Third: "111260001",
        Fourth: "111260001",
        Fifth: "111260001",
        Sixth: "111260001",
        Seventh: "111260001",
        Eighth: "111260001",
        Ninth: "111260001",
        Tenth: "111260001",
        Other: "111260001",
    };

    // State to hold the coverage flag for each floor
    const [floorCoverage, setFloorCoverage] = useState(initialFloorCoverage);

    // States for floor-specific room/bed details
    const [basementRooms, setBasementRooms] = useState("");
    const [basementBeds, setBasementBeds] = useState("");
    const [groundRooms, setGroundRooms] = useState("");
    const [groundBeds, setGroundBeds] = useState("");
    const [firstRooms, setFirstRooms] = useState("");
    const [firstBeds, setFirstBeds] = useState("");
    const [secondRooms, setSecondRooms] = useState("");
    const [secondBeds, setSecondBeds] = useState("");
    const [thirdRooms, setThirdRooms] = useState("");
    const [thirdBeds, setThirdBeds] = useState("");
    const [fourthRooms, setFourthRooms] = useState("");
    const [fourthBeds, setFourthBeds] = useState("");
    const [fifthRooms, setFifthRooms] = useState("");
    const [fifthBeds, setFifthBeds] = useState("");
    const [sixthRooms, setSixthRooms] = useState("");
    const [sixthBeds, setSixthBeds] = useState("");
    const [seventhRooms, setSeventhRooms] = useState("");
    const [seventhBeds, setSeventhBeds] = useState("");
    const [eighthRooms, setEighthRooms] = useState("");
    const [eighthBeds, setEighthBeds] = useState("");
    const [ninthRooms, setNinthRooms] = useState("");
    const [ninthBeds, setNinthBeds] = useState("");
    const [tenthRooms, setTenthRooms] = useState("");
    const [tenthBeds, setTenthBeds] = useState("");
    const [otherRooms, setOtherRooms] = useState("");
    const [otherBeds, setOtherBeds] = useState("");


    const [noOfUnit, setNoOfUnit] = useState(0);

    const [empCountOne, setEmpCountOne] = useState("");
    const [empCountTwo, setEmpCountTwo] = useState("");
    const [empCountThree, setEmpCountThree] = useState("");
    const [carpetAreaOne, setCarpetAreaOne] = useState("");
    const [carpetAreaTwo, setCarpetAreaTwo] = useState("");
    const [carpetAreaThree, setCarpetAreaThree] = useState("");
    const [firstFloor, setfirstFloor] = useState("");
    const [secondFloor, setSecondFloor] = useState("");
    const [thirdFloor, setThirdFloor] = useState("");
    const [totalEmpCount, setTotalEmpCount] = useState("");
    const [totalCarpetArea, setTotalCarpetArea] = useState("");
    const [accessPointCount, setAccessPointCount] = useState("");
    const [optionAccessPointCount, setOptionAccessPointCount] = useState([]);
    const [productName, setProductName] = useState("");
    const [optionProductName, setOptionProductName] = useState([]);

    // Special floor states
    const [specialFloorOne, setSpecialFloorOne] = useState(optionSpecialFloor[0]);
    const [specialFloorTwo, setSpecialFloorTwo] = useState(optionSpecialFloor[0]);
    const [specialFloorThree, setSpecialFloorThree] = useState(optionSpecialFloor[0]);

    const [selectContactFor, setSelectContactFor] = useState("");


    const handleSelectContactFor = (selected) => {
        setSelectContactFor(selected);
    };


    const [selectDoesCustNeedStaticIP, setSelectDoesCustNeedStaticIP] = useState("");

    const handleSelectCustNeedStaticIP = (selected) => {
        setSelectDoesCustNeedStaticIP(selected);
    }




    const handleNoOfUnit = (e) => {
        // setNoOfUnit(e.target.value)
        const value = parseInt(e.target.value);
        if (!isNaN(value) && value >= 0) {
            setNoOfUnit(value);
        } else {
            setNoOfUnit("");
        }
    };

    const incrementUnit = () => {
        if (noOfUnit < 3) {
            setNoOfUnit(prev => parseInt(prev || 0) + 1);
        }
    };

    // const decrementUnit = () => {
    //     if (noOfUnit > 0) {
    //         setNoOfUnit(prev => parseInt(prev || 1) - 1);
    //     }
    // };
    const decrementUnit = () => {
        if (noOfUnit > 0) {
            const newValue = parseInt(noOfUnit) - 1;

            // Clear inputs based on the unit being removed
            if (newValue === 2) {
                setThirdFloor("");
                setCarpetAreaThree("");
                setEmpCountThree("");
            } else if (newValue === 1) {
                setSecondFloor("");
                setCarpetAreaTwo("");
                setEmpCountTwo("");
            } else if (newValue === 0) {
                setfirstFloor("");
                setCarpetAreaOne("");
                setEmpCountOne("");
            }

            setNoOfUnit(newValue.toString());

            // Recalculate totals after clearing
            setTimeout(() => {
                const areas = [
                    newValue >= 1 ? Number(carpetAreaOne) : 0,
                    newValue >= 2 ? Number(carpetAreaTwo) : 0,
                    newValue >= 3 ? Number(carpetAreaThree) : 0,
                ];
                const employees = [
                    newValue >= 1 ? Number(empCountOne) : 0,
                    newValue >= 2 ? Number(empCountTwo) : 0,
                    newValue >= 3 ? Number(empCountThree) : 0,
                ];

                const totalArea = areas.reduce((acc, curr) => acc + (isNaN(curr) ? 0 : curr), 0);
                const totalEmployees = employees.reduce((acc, curr) => acc + (isNaN(curr) ? 0 : curr), 0);

                setTotalCarpetArea(totalArea.toString());
                setTotalEmpCount(totalEmployees.toString());
            }, 0); // Let state updates complete first
        }
    };


    const handleEmpCountOne = (e) => {
        setEmpCountOne(e.target.value);
    };
    const handleEmpCountTwo = (e) => {
        setEmpCountTwo(e.target.value);
    };
    const handleEmpCountThree = (e) => {
        setEmpCountThree(e.target.value);
    };
    const handleCarpetAreaOne = (e) => {
        setCarpetAreaOne(e.target.value);
    };
    const handleCarpetAreaTwo = (e) => {
        setCarpetAreaTwo(e.target.value);
    };
    const handleCarpetAreaThree = (e) => {
        setCarpetAreaThree(e.target.value);
    };
    const handleTotalEmpCount = (e) => {
        setTotalEmpCount(e.target.value);
    };
    const handleTotalCarpetArea = (e) => {
        setTotalCarpetArea(e.target.value);
    };
    const handleFirstFloor = (e) => {
        setfirstFloor(e.target.value);
        setSpecialFloorOne("")
    };
    const handleSecondFloor = (e) => {
        setSecondFloor(e.target.value);
        setSpecialFloorTwo("");
    };
    const handleThirdFloor = (e) => {
        setThirdFloor(e.target.value);
        setSpecialFloorThree("");
    };
    const handleSpecialFloorOne = (selected) => {
        setSpecialFloorOne(selected)
        setfirstFloor("");
    };
    const handleSpecialFloorTwo = (selected) => {
        setSpecialFloorTwo(selected);
        setSecondFloor("");

    };
    const handleSpecialFloorThree = (selected) => {
        setSpecialFloorThree(selected);
        setThirdFloor("");
    };

    useEffect(() => {
        if (Number(noOfUnit) > 0) {
            const areas = [carpetAreaOne, carpetAreaTwo, carpetAreaThree].map(Number);
            const employees = [empCountOne, empCountTwo, empCountThree].map(Number);

            const totalArea = areas.reduce((acc, curr) => acc + (isNaN(curr) ? 0 : curr), 0);
            const totalEmployees = employees.reduce((acc, curr) => acc + (isNaN(curr) ? 0 : curr), 0);

            setTotalCarpetArea(totalArea.toString());
            setTotalEmpCount(totalEmployees.toString());
        }
    }, [noOfUnit, carpetAreaOne, carpetAreaTwo, carpetAreaThree, empCountOne, empCountTwo, empCountThree]);


    // useEffect(() => {
    //     const floors = [];

    //     if (firstFloor !== "") floors.push(Number(firstFloor));
    //     if (secondFloor !== "") floors.push(Number(secondFloor));
    //     if (thirdFloor !== "") floors.push(Number(thirdFloor));

    //     if (floors.length > 1) {
    //         const min = Math.min(...floors);
    //         const max = Math.max(...floors);

    //         const uniqueFloors = [...new Set(floors)];
    //         const expectedRangeLength = max - min + 1;
    //         const isConsecutive = uniqueFloors.length === expectedRangeLength;

    //         if (!isConsecutive) {
    //             let message = "";

    //             // check pairwise violations
    //             if (firstFloor !== "" && secondFloor !== "" && Math.abs(Number(firstFloor) - Number(secondFloor)) > 1) {
    //                 message = `Units on ${firstFloor}th and ${secondFloor}th floors are not allowed - floors must be consecutive`;
    //             }
    //             else if (secondFloor !== "" && thirdFloor !== "" && Math.abs(Number(secondFloor) - Number(thirdFloor)) > 1) {
    //                 message = `Units on ${secondFloor}th and ${thirdFloor}th floors are not allowed - floors must be consecutive`;
    //             }
    //             else if (firstFloor !== "" && thirdFloor !== "" && Math.abs(Number(firstFloor) - Number(thirdFloor)) > 2) {
    //                 // extra check if first & third directly skip
    //                 message = `Units on ${firstFloor}th and ${thirdFloor}th floors are not allowed - floors must be consecutive`;
    //             }
    //             else {
    //                 message = `Entered floors ${floors.join(", ")} are not consecutive`;
    //             }

    //             toast.warning(message, { position: "bottom-center", autoClose: 2000 });

    //             // reset invalid floors (optional)
    //             setSecondFloor("");
    //             setThirdFloor("");
    //         }
    //     }
    // }, [firstFloor, secondFloor, thirdFloor, noOfUnit]);


    // Map special floors to numbers
    const specialFloorMap = {
        "Ground Floor": 0,
        "Basement 1": -1,
        "Basement 2": -2,
        "Basement 3": -3,
    };

    // Helper to get comparable value + label for messages
    const getFloorValue = (numFloor, specialFloor) => {
        if (specialFloor && specialFloor.value !== "") {
            return { value: Number(specialFloorMap[specialFloor.label]), label: specialFloor.label };
        }
        if (numFloor !== "") {
            return { value: Number(numFloor), label: `${numFloor}th` };
        }
        return null;
    };

    useEffect(() => {
        const unitFloors = [
            getFloorValue(firstFloor, specialFloorOne),
            getFloorValue(secondFloor, specialFloorTwo),
            getFloorValue(thirdFloor, specialFloorThree),
        ].filter(Boolean);

        if (unitFloors.length > 1) {
            const values = unitFloors.map(f => f.value);
            const min = Math.min(...values);
            const max = Math.max(...values);

            const uniqueFloors = [...new Set(values)];
            const expectedRangeLength = max - min + 1;
            const isConsecutive = uniqueFloors.length === expectedRangeLength;

            if (!isConsecutive) {
                let message = "";

                // Pairwise violations with readable labels
                if (unitFloors[0] && unitFloors[1] && Math.abs(unitFloors[0].value - unitFloors[1].value) > 1) {
                    message = `Units on ${unitFloors[0].label} and ${unitFloors[1].label} floors are not allowed - floors must be consecutive`;
                }
                else if (unitFloors[1] && unitFloors[2] && Math.abs(unitFloors[1].value - unitFloors[2].value) > 1) {
                    message = `Units on ${unitFloors[1].label} and ${unitFloors[2].label} floors are not allowed - floors must be consecutive`;
                }
                else if (unitFloors[0] && unitFloors[2] && Math.abs(unitFloors[0].value - unitFloors[2].value) > 2) {
                    message = `Units on ${unitFloors[0].label} and ${unitFloors[2].label} floors are not allowed - floors must be consecutive`;
                }
                else {
                    message = `Entered floors ${unitFloors.map(f => f.label).join(", ")} are not consecutive`;
                }

                toast.warning(message, { position: "bottom-center", autoClose: 4000 });

                // reset invalid floors (optional)
                setSecondFloor("");
                setThirdFloor("");
            }
        }
    }, [firstFloor, secondFloor, thirdFloor, specialFloorOne, specialFloorTwo, specialFloorThree, noOfUnit]);






    useEffect(() => {
        const fetchData = async () => {
            try {
                const url = process.env.REACT_APP_API_URL;
                const RequestBody = {
                    "Action": "recommendedPlan",
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "empCount": totalEmpCount,
                    "area": totalCarpetArea
                }
                const Response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(RequestBody),
                });
                const data = await Response.json();
                // console.log("data", data);

                if (data.Response) {
                    const options = data.Response.map(
                        (option) => ({
                            label: option.access_point_count,
                            value: option.access_point_count,
                        })
                    );
                    setOptionAccessPointCount(options);

                } else {
                    setOptionAccessPointCount([])
                }

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, [totalEmpCount, totalCarpetArea]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const url = process.env.REACT_APP_API_URL;
                const RequestBody = {
                    "Action": "getOfficePlanNameList",
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "empCount": totalEmpCount,
                    "area": totalCarpetArea
                }
                const Response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(RequestBody),
                });
                const data = await Response.json();
                // console.log("data", data);

                if (data.Response) {
                    const options = data.Response.map(
                        (option) => ({
                            label: option.plan_tier,
                            value: option.plan_tier,
                        })
                    );
                    setOptionProductName(options);

                } else {
                    setOptionProductName([])
                }

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, [totalEmpCount, totalCarpetArea]);

    const handleSelectAccessPointCount = (selected) => {
        setAccessPointCount(selected)
    }

    const handleSelectProductName = (selected) => {
        setProductName(selected)
    }



    useEffect(() => {
        const fetchGetQuotation = async () => {
            try {
                setLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;

                const requestData = {
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "Action": "getQuotation",
                    "OppId": OppId ? OppId : "",
                    "password": sessionStorage.getItem('password'),
                    "userName": sessionStorage.getItem('userName')
                }

                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                });

                const result = await response.json();
                if (Array.isArray(result?.Response?.Data) && result.Response.Data.length > 0) {
                    const option = result.Response.Data.find(item => item.OptionType) || result.Response.Data[0];
                    setProposalOptionType(option?.OptionType);
                }
                // console.log("API Response getQuotation:", result.Response.Data);
                setAllQuoteData(result?.Response?.Data)


            } catch (error) {
                console.error("Error fetching data:", error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchGetQuotation();
    }, []);

    const handleAddQuote = async () => {
        try {
            setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;

            const requestData = {
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "Action": "addQuotation",
                "OppId": OppId ? OppId : "",
                "password": sessionStorage.getItem('password'),
                "userName": sessionStorage.getItem('userName')
            }
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            if (result?.Response?.StatusCode == 200) {
                toast.success(result?.Response?.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                window.location.reload()
            }
        } catch (error) {
            console.error("Error fetching data:", error.message);
        } finally {
            setLoading(false);
        }
    }


    const handleWonQoute = async (quoteId) => {
        try {
            // setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestData =
            {
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "Action": "updateQuote",
                "QuoteID": quoteId,
                "Status": "Won",
                "password": sessionStorage.getItem('password'),
                "userName": sessionStorage.getItem('userName'),
                "CreateRevisedQuote": "Yes"
            }

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            if (result?.Response?.StatusCode == 200) {

                toast.success(result?.Response?.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                window.location.reload()
            }
        } catch (error) {
            console.error("Error fetching data:", error.message);
        } finally {
            // setLoading(false);
        }
    }

    const handleLostQoute = async (quoteId) => {
        try {
            // setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;

            const requestData = {
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "Action": "updateQuote",
                "QuoteID": quoteId,
                "Status": "Lost",
                "password": sessionStorage.getItem('password'),
                "userName": sessionStorage.getItem('userName'),
                "CreateRevisedQuote": "Yes"
            }
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            if (result?.Response?.StatusCode == 200) {
                toast.success(result?.Response?.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                window.location.reload()
            }
        } catch (error) {
            console.error("Error fetching data:", error.message);
        } finally {
            // setLoading(false);
        }
    }
    // Option sets for dropdowns
    const commonAreaOptions = [
        { value: "111260000", label: "Yes" },
        { value: "111260001", label: "No" },
    ];

    const elevatorOptions = [
        { value: "111260000", label: "Yes" },
        { value: "111260001", label: "No" },
    ];

    const existingConnectivityOptions = [
        { value: "1", label: "ILL" },
        { value: "2", label: "BB" },
        { value: "3", label: "New Building" },
    ];

    const barriersOptions = [
        { value: "1", label: "Building Gate" },
        { value: "2", label: "Office Reception" },
        { value: "3", label: "Cleared" },
    ];

    const officeAreaOptions = [
        { value: "1", label: "0 - 600" },
        { value: "2", label: "600 - 1200" },
        { value: "3", label: ">1200" },
    ];

    const applicationsOptions = [
        { value: "1", label: "Cloud & Storage (AWS, Azure, etc.)" },
        { value: "2", label: "Microsoft Teams, Zoom" },
        { value: "3", label: "HRMS" },
        { value: "4", label: "CRM (Salesforce, Zoho, etc.)" },
        { value: "5", label: "ERP / SAP" },
        { value: "6", label: "Microsoft Dynamics 365" },
    ];

    const optionStaticIp = [
        { label: "Yes", value: "111260000" },
        { label: "No", value: "111260001" },
    ]
    // const productNameOptions = [
    //     { value: "1", label: "Pro-Fi Broadband" },
    //     { value: "2", label: "DIA" },
    //     { value: "3", label: "Business Wi-Fi with Connectivity" },
    //     { value: "4", label: "Business Wi-Fi without Connectiviity" },
    // ];

    const companyTurnoverOptions = [
        { value: "1", label: "<1 Cr" },
        { value: "2", label: "1 - 10 Cr" },
        { value: "3", label: "10 - 100 Cr" },
        { value: "4", label: "100 - 500 Cr" },
        { value: "5", label: ">500 Cr" },
    ];

    // const officeEmployeeCountOptions = [
    //     { value: "1", label: "Less than or equal to 25 employees" },
    //     { value: "2", label: "25 to 50 employees" },
    // ];

    // const coverageAreaRangeOptions = [
    //     { value: "1", label: "600 to 1,500 sq. ft." },
    //     { value: "2", label: "1,500 to 2,500 sq. ft." },
    //     { value: "3", label: "1,000 to 1,500 sq. ft." },
    // ];

    // existingConnectivityOptions

    // Options for the multi-select floors.
    // The value here is the floor identifier; the actual coverage flag is determined dynamically.
    const floorOptions = [
        { value: "Basement", label: "Basement Coverage Required" },
        { value: "Ground", label: "Ground Floor Coverage Required" },
        { value: "First", label: "First Floor Coverage Required" },
        { value: "Second", label: "Second Floor Coverage Required" },
        { value: "Third", label: "Third Floor Coverage Required" },
        { value: "Fourth", label: "Fourth Floor Coverage Required" },
        { value: "Fifth", label: "Fifth Floor Coverage Required" },
        { value: "Sixth", label: "Sixth Floor Coverage Required" },
        { value: "Seventh", label: "Seventh Floor Coverage Required" },
        { value: "Eighth", label: "Eighth Floor Coverage Required" },
        { value: "Ninth", label: "Ninth Floor Coverage Required" },
        { value: "Tenth", label: "Tenth Floor Coverage Required" },
        { value: "Other", label: "Any other Area/Floor Coverage Required" },
    ];

    // Handler for multi-select change: update selectedFloors and floorCoverage mapping.
    const handleFloorSelectChange = (selected) => {
        setSelectedFloors(selected);
        // Start with all floors defaulting to "No" (111260001)
        const newCoverage = { ...initialFloorCoverage };
        if (selected && selected.length) {
            selected.forEach((item) => {
                // When a floor is selected, update its coverage value to "Yes" (111260000)
                newCoverage[item.value] = "111260000";
            });
        }
        setFloorCoverage(newCoverage);
    };

    const [selectPGType, setSelectPGType] = useState(null);
    const [selectTenantType, setSelectTenantType] = useState(null);
    const [selectContactDesignation, setSelectContactDesignation] = useState(null);

    // Handler for PG Type drop-down
    const handleSelectPGType = (selectedOption) => {
        setSelectPGType(selectedOption);
        setOpportunityData({
            ...opportunityData,
            pgType: selectedOption ? selectedOption.value : "",
        });
    };

    // Handler for Tenant Type drop-down
    const handleSelectTenantType = (selectedOption) => {
        setSelectTenantType(selectedOption);
        setOpportunityData({
            ...opportunityData,
            tenantType: selectedOption ? selectedOption.value : "",
        });
    };

    // Handler for Contact Designation drop-down
    const handleSelectContactDesignation = (selectedOption) => {
        setSelectContactDesignation(selectedOption);
        setOpportunityData({
            ...opportunityData,
            contactDesignation: selectedOption ? selectedOption.value : "",
        });
    };
    const [selectExistingInternetProvider, setSelectExistingInternetProvider] = useState(null);
    const handleSelectExistingInternetProvider = (selectedOption) => {
        setSelectExistingInternetProvider(selectedOption);
        setOpportunityData((prev) => ({
            ...prev,
            existingInternetProvider: selectedOption ? selectedOption.value : "",
        }));
    };

    // Existing Internet Outflow Per Month
    const [selectExistingInternetOutflow, setSelectExistingInternetOutflow] = useState(null);
    const handleSelectExistingInternetOutflow = (selectedOption) => {
        setSelectExistingInternetOutflow(selectedOption);
        setOpportunityData((prev) => ({
            ...prev,
            existingInternetOutflow: selectedOption ? selectedOption.value : "",
        }));
    };

    // Current Infra (using placeholder options; update as needed)
    const [selectCurrentInfra, setSelectCurrentInfra] = useState(null);
    const handleSelectCurrentInfra = (selectedOption) => {
        setSelectCurrentInfra(selectedOption);
        setOpportunityData((prev) => ({
            ...prev,
            currentInfra: selectedOption ? selectedOption.value : "",
        }));
    };

    // Pain Points (multi-select)
    const [selectPainPoints, setSelectPainPoints] = useState([]);

    const handleSelectPainPoints = (selectedOptions) => {
        setSelectPainPoints(selectedOptions);
        setOpportunityData((prev) => ({
            ...prev,
            painPoints: selectedOptions ? selectedOptions.map((option) => option.value) : [],
        }));
    };

    // Urgent Triggers
    const [selectUrgentTriggers, setSelectUrgentTriggers] = useState(null);
    const handleSelectUrgentTriggers = (selectedOption) => {
        setSelectUrgentTriggers(selectedOption);
        setOpportunityData((prev) => ({
            ...prev,
            urgentTriggers: selectedOption ? selectedOption.value : "",
        }));
    };

    // Spectra Relationship
    const [selectSpectraRelationship, setSelectSpectraRelationship] = useState(null);
    const handleSelectSpectraRelationship = (selectedOption) => {
        setSelectSpectraRelationship(selectedOption);
        setOpportunityData((prev) => ({
            ...prev,
            spectraRelationship: selectedOption ? selectedOption.value : "",
        }));
    };
    const paymentoptions = [
        { value: "111260001", label: "Agreed" },
        { value: "111260002", label: "Not Agreed" },
    ];
    const [selectPayment, setselectPayment] = useState(null);
    const handleselectPayment = (selectedOption) => {
        setselectPayment(selectedOption);
        setOpportunityData((prev) => ({
            ...prev,
            paymentTerms: selectedOption ? selectedOption.value : "",
        }));
    };
    // Role
    const [selectRole, setSelectRole] = useState(null);
    const handleSelectRole = (selectedOption) => {
        setSelectRole(selectedOption);
        setOpportunityData((prev) => ({
            ...prev,
            role: selectedOption ? selectedOption.value : "",
        }));
    };

    const handleCompanyChange = (selectedOption) => {
        setSelectedCompany(selectedOption);
    };

    const handleSelectGroup = (selectGroup) => {
        setSelectGroup(selectGroup);
    };

    const handleSelectRelationship = (selectGroup) => {
        setSelectRelationship(selectGroup);
    };

    const handlePriceListChange = (selectOption) => {
        setSelectedPriceList(selectOption);
    };

    const handleSelectFirmType = (selectFirmType) => {
        setSelectedFirmType(selectFirmType);
    };

    const handleIndustryChnage = (selected) => {
        setSelectIndustry(selected);
    };

    const handleSelectSolutation = (selectSolutation) => {
        setSelectSolutaton(selectSolutation);
    };

    const handleSelectCountry = (selectOption) => {
        setSelectCountry(selectOption);
    };

    const handleSelectState = (selectOption) => {
        setSelectState(selectOption);
    };

    const handleSelectCustomerSeg = (selectCustomerSeg) => {
        setSelectCustomerSeg(selectCustomerSeg);
    };

    const handleSelectTurnOver = (selectTurnOver) => {
        setSelectTurnOver(selectTurnOver);
    };

    const handleSelectMedia = (selectMedia) => {
        setSelectedMedia(selectMedia);
    };

    const handleSelectServiceProvider1 = (exServiceProvider) => {
        setSelectExServiceProvider1(exServiceProvider);
    };

    const handleInterestedFirewall = (firewall) => {
        setSelectInterestedFirewall(firewall);
    }

    const handleInterestedVPN = (value) => {
        // console.log(value);

        setSelectInteretedVPN(value);
    }

    const handleInterestedManageWiFi = (value) => {
        setSelectInterestedManageWiFi(value);
    }

    const yyyymmddFormat = (dateStr) => {
        if (!dateStr) return "";
        const parts = dateStr.split("-");
        if (parts.length !== 3) return "";
        if (parts[0].length === 4) {
            return dateStr; // Already in YYYY-MM-DD format
        } else {
            // Convert from DD-MM-YYYY to YYYY-MM-DD
            return `${parts[2]}-${parts[1]}-${parts[0]}`;
        }
    };

    const [minPoNext, setMinPoNext] = useState();
    const [opportunityDataWifi, setOpportunityDataWifi] = useState({})
    const [opportunityData, setOpportunityData] = useState({
        QuoteStatus: "",
        userType: "",
        noUserLicences: "",
        speedPerUser: "",
        planValidity: "",
        dataValume: "",
        devicesPerUser: "",
        loginMechanism: "",
        Remarks: "",
        Redunancy: false,
        Block: "",
        Status: "",
        Statuscode: "",
        OppId: "",
        OppStatus: "",
        LeadId: "",
        PriceList: "",
        Topic: "",
        StateId: "",
        CityId: "",
        AreaId: "",
        BuildingId: "",
        SpecificArea: "",
        SpecificBuilding: "",
        Building_BuildingStatus: "",
        NoOfUsers: "",
        NoOfBeds: "",
        IndustryId: "",
        ApprovalRequiredFlag: "",
        Reason: "",
        Area: "",
        Subbusinesssegment: "",
        Businesssegment: "",
        State: "",
        Salutation: "",
        Relationship: "",
        PostalCode: "",
        Mobilephone: "",
        Media: "",
        Lco: null,
        Industry: "",
        Group: "",
        Floor: "",
        TPFeasibilty: "",
        CreateAreaOrBuilding: false,
        Firmtype: "",
        Product: "",
        ProductSegment: "",
        FeasibilityRequired: false,
        Existingprovider: "",
        Emailaddress: "",
        Country: "",
        Companyname: "",
        City: "",
        leadname: "",
        Buildingname: "",
        BuildingNo: "",
        ContactPerson: "",
        CustomerSegment: "",
        LastMileType: "",
        UpTimesla: "",
        Firewall: "",
        CompanySelf: "",
        PoLock: "",
        Price: "",
        OriginatingLead: "",
        FirewallAwc: "",
        PoNext: "",
        Company: "",
        TotalAmount: "",
        VerticalID: "",
        TypeOfOrder: "",
        PocClosureDate: "",
        TurnOver: "",
        SocietyName: "",
        SocietyId: "",
        SocietyStatus: "",
        HousePlotFlatNo: "",
        BlockTowerNumber: "",
        OTCAmount: "",
        SDAmount: "",
        RCAmount: "",
        sdDiscount: "",
        rcDiscount: "",
        otcDiscount: "",
        exOtcDiscount: "",
        exSdDiscount: "",
        commonAreaName: "",
        exRcDiscount: "",
        NumberofInternetUsers: "",
        remark: ""
    });
    const modalRef = useRef(null);
    useEffect(() => {
        const fetchGetPraposal = async () => {
            try {
                setLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;

                const requestData = {
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "Action": "getProposalList",
                    "OpportunityID": OppId ? OppId : "",
                    "password": sessionStorage.getItem('password'),
                    "userName": sessionStorage.getItem('userName')
                }

                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                });

                const result = await response.json();

                // console.log("API Response fetchGetPraposal:", result.Response.Data);
                setAllPraposalData(result?.Response?.Data)


            } catch (error) {
                console.error("Error fetching data:", error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchGetPraposal();
    }, []);

    // Function to convert a base64 string to a Blob
    const base64ToBlob = (base64, mime) => {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: mime });
    };

    const handleDownload = (data) => {
        // Ensure there is a base64 string available
        const base64String = data.ProposalFileContent;
        if (!base64String) {
            console.error("No base64 data available for download.");
            return;
        }

        // Set the file name and MIME type (adjust if needed)
        const fileName = data.ProposalDocName || "downloaded_document.pdf";
        const mimeType = "application/pdf"; // Change if your document type is different

        // Convert base64 string to a Blob object
        const blob = base64ToBlob(base64String, mimeType);

        // Create a URL for the Blob object
        const blobUrl = URL.createObjectURL(blob);

        // Create a temporary anchor element to trigger the download
        const downloadLink = document.createElement("a");
        downloadLink.href = blobUrl;
        downloadLink.download = fileName;

        // Append the link to the body (required for Firefox)
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // Clean up and remove the temporary link
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(blobUrl);
    };
    useEffect(() => {
        const modalElement = modalRef.current;
        if (modalElement) {
            const handleShowModal = (event) => {
                // Button that triggered the modal
                const button = event.relatedTarget;
                // Extract info from data-bs-* attributes
                const recipient = button.getAttribute('data-bs-whatever');
                // Update the modal's content.
                const modalTitle = modalElement.querySelector('.modal-title');
                const modalBodyInput = modalElement.querySelector('.modal-body input');

                if (modalTitle) {
                    modalTitle.textContent = 'New message to ' + recipient;
                }
                if (modalBodyInput) {
                    modalBodyInput.value = recipient;
                }
            };

            modalElement.addEventListener('show.bs.modal', handleShowModal);

            // Cleanup the event listener when the component unmounts
            return () => {
                modalElement.removeEventListener('show.bs.modal', handleShowModal);
            };
        }
    }, []);
    const handleChange = (e) => {
        e.preventDefault()
        const { name, value, type } = e.target;

        // console.log(name, value);

        setOpportunityData((prevData) => ({
            ...prevData,
            [name]: type === "number" ? String(value) : value,
        }));

        if (name == "PoLock") {
            let minPoNext = new Date(new Date(value).setFullYear(new Date(value).getFullYear() + 1)).toISOString().split("T")[0]
            setMinPoNext(minPoNext)
            // console.log(PoNext); 
        }
    };



    const discountInput = async (e) => {
        const { name, value, type } = e.target;
        // console.log(name, value, getOTCProd[0], getRCProd[0]);

        // if(!selectedRelatedProduct?.value){
        //   toast.error("Select related product");
        //   return
        // }

        if (name == 'otcDiscount') {

            let req = { oppid: OppId, productid: getOTCProd[0].ProductId, discount: opportunityData.otcDiscount };
            const result = await api.updateOppProduct(req);
            // console.log(result);

        } else if (name == 'rcDiscount') {

            let req = { oppid: OppId, productid: getRCProd[0].ProductId, discount: opportunityData.rcDiscount };
            const result = await api.updateOppProduct(req);
            // console.log(result);

        } else if (name == 'OTCAmount') {
            if (otcAmount > (type === "number" ? String(value) : value)) {
                toast.warning("OTC Amount can't be less than the existing amount.");
                return;
            }
            // console.log(opportunityData.OTCAmount);

            let req = { oppid: OppId, productid: getOTCProd[0].ProductId, priceperunit: opportunityData.OTCAmount, pricing: "Override Price" };
            const result = await api.updateOppProduct(req);
            // console.log(result);

        } else if (name == 'RCAmount') {
            if (rcAmount > (type === "number" ? String(value) : value)) {
                toast.warning("RC Amount can't be less than the existing amount.");
                return;
            }

            let req = { oppid: OppId, productid: getRCProd[0].ProductId, priceperunit: opportunityData.RCAmount, pricing: "Override Price" };
            const result = await api.updateOppProduct(req);
            // console.log(result);

        }
    };


    const manageDocClickBusiness = () => {
        navigate(`/businessCAFmangeNewDoc?OppId=${OppId}`);
        // BusinessSAFmanageFormDOC() ;
    };


    const handleCreateCaf = () => {
        // console.log("leadid", leadid);

        navigate(`/businessCAFmanageForm?OppId=${OppId}&LeadId=${leadid}`)
    };

    const optionLost = [
        // { name: "Disqualify", code: "" },
        { label: "Not Interested", value: "569480000" },
        { label: "Delay in Response", value: "569480002" },
        { label: "Pricing issue", value: "569480003 " },
        { label: "Location Is Non-RFS", value: " 569480004" },
        { label: "Existing Customer", value: "569480007 " },
        { label: "Customer Is defaulter", value: "569480008" },
        { label: "Broadband/Home user", value: "569480010" },
        { label: "Duplicate Lead", value: "569480011" },
        { label: "Incomplete information", value: "569480012 " },
        { label: "Wrong Number", value: "569480014 " },
        { label: "Not Contactable", value: "569480015" },
        { label: "Language Barrier", value: "569480016" },
    ];

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            // backgroundColor: "black",
            color: "white",
            // border: "none",
            boxShadow: state.isFocused ? "none" : provided.boxShadow,
            textAlign: "center",
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "white",
        }),
        option: (provided, state) => ({
            ...provided,
            // backgroundColor: state.isFocused ? 'blue' : 'black',
            color: "black",
            textAlign: "center",
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: '#f0f0f0',
            borderRadius: '4px',
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: '#333',
        }),
    };

    // ← this now gets an array of options
    const handleChanged = (options) => {
        setSelectedReasons(options || [])
    }

    const MultiValueRemove = (props) => (
        <RSComponents.MultiValueRemove {...props}>
            <span style={{ color: '#900', fontSize: '16px', lineHeight: '1' }}>×</span>
        </RSComponents.MultiValueRemove>
    )

    const handleLost = async () => {
        if (!selectedReasons.length) {
            toast.warning('Please pick at least one reason.')
            return
        }

        const reasonList = selectedReasons.map(o => o.label).join(', ')
        const apiUrl = process.env.REACT_APP_API_URL;
        const payload = {
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            Action: 'opportunityDisqualify',           // ← your new API action
            userName: sessionStorage.getItem('userName'),
            password: sessionStorage.getItem('password'),
            OppID: OppId,                   // fixed key name
            ReasonForDisqualify: reasonList
        }

        try {
            const res = await fetch(apiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            })
            const data = await res.json()

            if (data.StatusCode === '200' || data.Response?.StatusCode === 200) {
                toast.success('Opportunity Lost successfully!', {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                })
                navigate('/businessOpportunityProWifi')
            } else {
                toast.error(data.Response?.Message || data.Message || 'Failed to Lost')
            }
        } catch (err) {
            console.error(err)
            toast.error('Network error, please try again.')
        }
    };

    // const handleLost = async () => {
    //     // console.log("Opportunity marked as Lost");
    //     // {
    //     //     "Action": "lostOpportunity",
    //     //     "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
    //     //     "Oppid": "O-03-2024-140887",
    //     //     "password": "Target@2021#@",
    //     //     "status": "569480000",
    //     //     "userName": "manager1"
    //     // }
    //     try {
    //         setLoading(true);
    //         const apiUrl = process.env.REACT_APP_API_URL;
    //         const requestData = {
    //             Action: "lostOpportunity",
    //             Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
    //             Oppid: OppId,
    //             password: sessionStorage.getItem('password'),
    //             // status: optionQualify.value,
    //             "status": "569480000",
    //             userName: sessionStorage.getItem('userName'),
    //         };
    //         // console.log(requestData);return


    //         const response = await fetch(apiUrl, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //             body: JSON.stringify(requestData),
    //         });

    //         const data = await response.json();
    //         // console.log(data);

    //         // Check for a successful API response
    //         if (data.Response.StatusCode === 200) {
    //             toast.success("Opportunity marked as LOST", {
    //                 position: toast.POSITION.BOTTOM_CENTER,
    //                 autoClose: 1500,
    //             });
    //             navigate(`/businessOpportunityProWifi`)
    //             // Swal.fire({
    //             //   title: '<div style="font-size: 22px; margin-top:5px;">Action Required</div>',
    //             //   text: "Please submit for approval as discount added in OTC or SD amount",
    //             //   confirmButtonText:
    //             //     '<span style="font-size: 15px;">Submit for Approval</span>',
    //             //   confirmButtonColor: "rgb(148,101,170)",
    //             // }).then(async (result) => {
    //             //   if (result.isConfirmed) {
    //             //     const ApiUrl = process.env.REACT_APP_API_URL;
    //             //     const requestBody = {
    //             //       "Action": "BBApprovalProcessDigi",
    //             //       "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
    //             //       "userName": sessionStorage.getItem('userName'),
    //             //       "password": sessionStorage.getItem('password'),
    //             //       "OpportunityID": OppId,
    //             //       "ApprovalRemarks": "Ignore"
    //             //     };
    //             //     const Response = await fetch(ApiUrl, {
    //             //       method: "POST",
    //             //       headers: {
    //             //         "Content-Type": "application/json",
    //             //       },
    //             //       body: JSON.stringify(requestBody),
    //             //     });
    //             //     const data = await Response.json();
    //             //     console.log(data)
    //             //     if (data.StatusCode == "200") {
    //             //       // navigate("/opportunity");
    //             //     }
    //             //   }
    //             // })
    //         } else {
    //             if (data.Response.Message == "The opportunity can not be closed.") {
    //                 toast.warning("Please Mark the Quote as Won or Lost.", {
    //                     position: toast.POSITION.BOTTOM_CENTER,
    //                     autoClose: 1500,
    //                 });
    //             } else {
    //                 toast.warning(data.Response.Message, {
    //                     position: toast.POSITION.BOTTOM_CENTER,
    //                     autoClose: 1500,
    //                 });
    //             }

    //         }
    //     } catch (error) {
    //         console.error("Error during API call:", error);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const generateFeasibility = async (opp) => {
        const genfeas = await api.generateFeasibility(opp);
        // console.log(genfeas);
        if (genfeas?.Status == "Success") {
            toast.success(genfeas.Response.Message, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            })
            setTimeout(() => {
                window.location.reload()
            }, 1500);
        } else {
            toast.error("Feasibility Not Generated.")
        }
    };

    const createSurveyTask = async (opp) => {
        const genfeas = await api.createSurveyTask(opp);
        // console.log(genfeas);
        if (genfeas?.Status == "Success") {
            toast.success(genfeas.Response.Message)
            setTimeout(() => {
                window.location.reload()
            }, 1500);
        } else if ((genfeas.Response.Message).includes("Survey Task already generated")) {
            toast.warning("Survey Task already generated")
        } else {
            toast.error("Survey Task already generated")
        }
    };




    const handleIconClick = (formId) => {
        // if (activeForm !== formId) {
        //   setActiveForm(formId);
        // }

        setActiveForm((prevActiveBox) =>
            prevActiveBox === formId ? null : formId
        );
    };
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    const OppId = searchParams.get("OppId");
    const CafId = searchParams.get("CafId");
    const navigate = useNavigate();
    // const redirectLeadPage = () => {
    //   navigate("/businessLead");
    // };

    useEffect(() => {
        const fetchData = async () => {
            const feasibilityData = await api.getFeasibility(OppId);
            const preSalesData = await api.getPreTask(OppId);
            const quoteData = await api.getQuote(OppId);
            const getApprovalData = await api.getApproval(OppId);

            // console.log(getApprovalData.Response.Data);
            // console.log(quoteData?.Response);
            // console.log(preSalesData);

            const allDoaApproved = getApprovalData?.Response?.Data?.every(approval => approval.StatusReason === "Approved" && approval.Status == "Active");
            const allFeasibilityApproved = feasibilityData?.Response?.Data?.every(approval => approval.FeasibilityStatus == "1");

            allDoaApproved !== undefined && setDoaApprovedFlag(allDoaApproved);
            allFeasibilityApproved !== undefined && setFeasibilityApprovedFlag(allFeasibilityApproved);

            // getApprovalData?.Response?.Data?.length > 0 && setDoaApprovalData(getApprovalData?.Response?.Data)
            const activeApproval = getApprovalData?.Response?.Data?.filter(approval => approval.Status == "Active")
            const sortedApproval = activeApproval?.sort((a, b) => parseInt(a.Name.split(" ")[0]) - parseInt(b.Name.split(" ")[0]));
            sortedApproval?.length > 0 && setDoaApprovalData(sortedApproval)

            feasibilityData?.Response?.Data?.length > 0 && setFeasibilityData(feasibilityData?.Response?.Data)
            preSalesData?.Response?.Data?.length > 0 && setPreSalesTask(preSalesData?.Response?.Data)
            // console.log(quoteData);

            setQuoteDetail(quoteData?.Response?.Data)
            // const approvalData = await getApproval();
            // setFeasibilityData(feasibilityData.Response.Data)
            // const generateFeasibilityRes = await generateFeasibility();

            // console.log(feasibilityData?.Response?.Data);

            const getSurveyTaskData = await api.getSurveyTask(OppId);
            const userlicencegrid = await api.getUserlicencegrid(OppId);
            // console.log(userlicencegrid);
            // console.log([getSurveyTaskData?.Response]);
            const allSurveyApproved = getSurveyTaskData?.Response?.Data?.every(approval => approval.Status === "Approved");
            allSurveyApproved !== undefined && setSurveyApprovedFlag(allSurveyApproved);
            [getSurveyTaskData?.Response].length > 0 && setSurveyTaskData([getSurveyTaskData?.Response])


            if (userlicencegrid?.Status == "Success") {
                setUserlicencegridData(userlicencegrid?.Response?.userlicense)
            }
        };

        fetchData();
        // generateFeasibility();
        // createApproval();
        // createQuote();
        // Cleanup function not needed in this case
    }, []);


    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestBody = {
                    Action: "getopportunity",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    LeadId: "",
                    OppId: OppId ? OppId : "",
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName'),
                };
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                });

                const responsedata = await response.json();
                const responseData = responsedata?.Response?.Data?.[0];
                // console.log(responseData?.ProductSegment, responseData?.Building_BuildingStatus, responseData?.Redunancy, responseData?.InfraFlag);

                // console.log("getLeads1" ,responsedata1);
                if (responsedata?.Status === "Success" && responseData) {
                    const pgInfo = responseData.PgInfo;
                    setmeetingcounter(pgInfo.MeetingCounter);
                    // console.log("pgInfo.MeetingCounter", pgInfo.MeetingCounter);


                    if ((responseData?.ProductSegment == "BIA" || responseData?.ProductSegment == "Internet Leased Line (ILL)") && responseData?.Building_BuildingStatus == "Non-RFS") {
                        setEnableGenerateFeasibilityBtn(true)
                        setIsRedundancyLocked(false)
                    }
                    if ((responseData?.ProductSegment == "BIA" || responseData?.ProductSegment == "Internet Leased Line (ILL)") && responseData?.Building_BuildingStatus !== "Non-RFS") {
                        setEnableGenerateFeasibilityBtn(false)
                        setIsRedundancyLocked(true)
                    }
                    if ((responseData?.ProductSegment == "Secured Managed Internet" || responseData?.ProductSegment == "Managed Office Solution") && responseData?.Redunancy == true) {
                        setEnableGenerateFeasibilityBtn(true)
                        setIsRedundancyLocked(true)
                    }
                    if (responseData?.ProductSegment == "Managed Wi-Fi Business" && responseData?.InfraFlag !== 'YES' && responseData?.Redunancy == true) {
                        setEnableGenerateFeasibilityBtn(true)
                        setIsRedundancyLocked(false)
                    }
                    if (responseData?.ProductSegment == "Managed Wi-Fi Business" && responseData?.InfraFlag == 'YES' && responseData?.Redunancy == true) {
                        setEnableGenerateFeasibilityBtn(false)
                        setIsRedundancyLocked(true)
                    }


                    // Update the dropdown state variables by mapping the API value to the corresponding option
                    setSelectPGType(pgTypeOptions.find(option => option.value === pgInfo.PGType) || null);
                    setSelectTenantType(tenantTypeOptions.find(option => option.value === pgInfo.TenantType) || null);
                    setSelectContactDesignation(contactDesignationOptions.find(option => option.value === pgInfo.Designation) || null);
                    setSelectRole(roleOptions.find(option => option.value === pgInfo.Role) || null);
                    setSelectExistingInternetProvider(
                        existingInternetProviderOptions.find(option => option.value === pgInfo.ExistingInternetProvider) || null
                    );
                    setSelectExistingInternetOutflow(
                        existingInternetOutflowOptions.find(option => option.value === pgInfo.ExistingInternetOutflowPerMonth) || null
                    );
                    setSelectUrgentTriggers(
                        urgentTriggersOptions.find(option => option.value === pgInfo.UrgentTriggers) || null
                    );
                    setSelectSpectraRelationship(
                        spectraRelationshipOptions.find(option => option.value === pgInfo.SpectraRelationship) || null
                    );
                    const currentInfraOption =
                        currentInfraOptions.find((opt) => opt.value === pgInfo.CurrentInfra) || null;
                    setSelectCurrentInfra(currentInfraOption);

                    // Populate additional PgInfo values for total floors and floor coverage details
                    setTotalFloors(pgInfo.TotalNumberofFloors || "");
                    setCommonArea(commonAreaOptions.find(item => item.value === pgInfo.CommonArea) || null);
                    setElevator(elevatorOptions.find(item => item.value === pgInfo.Elevator) || null);
                    setExistingConnectivity(existingConnectivityOptions.find(item => item.value === pgInfo.ExistingConnectivity) || null);
                    setBarriers(barriersOptions.find(item => item.value === pgInfo.Barriers) || null);
                    setSelectContactFor(
                        optionContactFor.find(option => option.value === pgInfo?.ContactFor)
                    );
                    // console.log("selectContactFor", selectContactFor);
                    setNoOfUnit(pgInfo?.NoOfUnits);
                    setTotalEmpCount(pgInfo?.EmployeeCount);
                    setTotalCarpetArea(pgInfo?.OfficeArea);
                    // if (responseData?.UnitsSection) {
                    //     setfirstFloor(responseData?.UnitsSection[0]?.Floor);
                    //     setSecondFloor(responseData?.UnitsSection[1]?.Floor);
                    //     setThirdFloor(responseData?.UnitsSection[2]?.Floor);

                    //     setCarpetAreaOne(responseData?.UnitsSection[0]?.CarepetArea);
                    //     setCarpetAreaTwo(responseData?.UnitsSection[1]?.CarepetArea);
                    //     setCarpetAreaThree(responseData?.UnitsSection[2]?.CarepetArea);

                    //     setEmpCountOne(responseData?.UnitsSection[0]?.EmployeeCount);
                    //     setEmpCountTwo(responseData?.UnitsSection[1]?.EmployeeCount);
                    //     setEmpCountThree(responseData?.UnitsSection[2]?.EmployeeCount);
                    // }
                    if (Array.isArray(responseData?.UnitsSection)) {
                        const units = responseData.UnitsSection;

                        setfirstFloor(units[0]?.Floor || "");
                        setSecondFloor(units[1]?.Floor || "");
                        setThirdFloor(units[2]?.Floor || "");

                        setCarpetAreaOne(units[0]?.CarepetArea || "");
                        setCarpetAreaTwo(units[1]?.CarepetArea || "");
                        setCarpetAreaThree(units[2]?.CarepetArea || "");

                        setEmpCountOne(units[0]?.EmployeeCount || "");
                        setEmpCountTwo(units[1]?.EmployeeCount || "");
                        setEmpCountThree(units[2]?.EmployeeCount || "");

                        setSpecialFloorOne(optionSpecialFloor.find(item => item.value === units[0]?.SpecialFloors) || optionSpecialFloor[0]);
                        setSpecialFloorTwo(optionSpecialFloor.find(item => item.value === units[1]?.SpecialFloors) || optionSpecialFloor[0]);
                        setSpecialFloorThree(optionSpecialFloor.find(item => item.value === units[2]?.SpecialFloors) || optionSpecialFloor[0]);

                    }
                    const filterStaticIp = optionStaticIp?.find(item => item?.value == String(pgInfo?.Doesthecustomerneedastaticip))?.label;
                    if (filterStaticIp) {
                        setSelectDoesCustNeedStaticIP({
                            value: pgInfo?.Doesthecustomerneedastaticip,
                            label: filterStaticIp,
                        });
                    }
                    // setOfficeArea(officeAreaOptions.find(item => item.value === pgInfo.OfficeArea) || null);
                    setApplications(applicationsOptions.find(item => item.value === pgInfo.Applications) || null);
                    // setProductName(productNameOptions.find(item => item.value === pgInfo.ProductName) || null);
                    setCompanyTurnover(companyTurnoverOptions.find(item => item.value === pgInfo.CompanyTurnover) || null);


                    setFloorCoverage({
                        Basement: pgInfo.BasementCoverageRequired || "111260001",
                        Ground: pgInfo.GroundFloorCoverageRequired || "111260001",
                        First: pgInfo.FirstFloorCoverageRequired || "111260001",
                        Second: pgInfo.SecondFloorCoverageRequired || "111260001",
                        Third: pgInfo.ThirdFloorCoverageRequired || "111260001",
                        Fourth: pgInfo.FourthFloorCoverageRequired || "111260001",
                        Fifth: pgInfo.FifthFloorCoverageRequired || "111260001",
                        Sixth: pgInfo.SixthFloorCoverageRequired || "111260001",
                        Seventh: pgInfo.SeventhFloorCoverageRequired || "111260001",
                        Eighth: pgInfo.EighthFloorCoverageRequired || "111260001",
                        Ninth: pgInfo.NinthFloorCoverageRequired || "111260001",
                        Tenth: pgInfo.TenthFloorCoverageRequired || "111260001",
                        Other: pgInfo.AnyAreaFloorCoverageRequired || "111260001",
                    });

                    // Update floor-specific room and bed details
                    setBasementRooms(pgInfo.NoOfRoomsinBasement || "");
                    setBasementBeds(pgInfo.NoOfBedsInBasement || "");
                    setGroundRooms(pgInfo.NoOfRoomsinGroundFloor || "");
                    setGroundBeds(pgInfo.NoOfBedsInGroundFloor || "");
                    setFirstRooms(pgInfo.NoOfRoomsinFirstFloor || "");
                    setFirstBeds(pgInfo.NoOfBedsInFirstFloor || "");
                    setSecondRooms(pgInfo.NoOfRoomsinSecondFloor || "");
                    setSecondBeds(pgInfo.NoOfBedsInSecondFloor || "");
                    setThirdRooms(pgInfo.NoOfRoomsinThirdFloor || "");
                    setThirdBeds(pgInfo.NoOfBedsInThirdFloor || "");
                    setFourthRooms(pgInfo.NoOfRoomsinFourthFloor || "");
                    setFourthBeds(pgInfo.NoOfBedsInFourthFloor || "");
                    setFifthRooms(pgInfo.NoOfRoomsinFifthFloor || "");
                    setFifthBeds(pgInfo.NoOfBedsInFifthFloor || "");
                    setSixthRooms(pgInfo.NoOfRoomsinSixthFloor || "");
                    setSixthBeds(pgInfo.NoOfBedsInSixthFloor || "");
                    setSeventhRooms(pgInfo.NoOfRoomsinSeventhFloor || "");
                    setSeventhBeds(pgInfo.NoOfBedsInSeventhFloor || "");
                    setEighthRooms(pgInfo.NoOfRoomsinEighthFloor || "");
                    setEighthBeds(pgInfo.NoOfBedsInEightFloor || ""); // API field is "NoOfBedsInEightFloor"
                    setNinthRooms(pgInfo.NoOfRoomsinNinthFloor || "");
                    setNinthBeds(pgInfo.NoOfBedsInNinthFloor || "");
                    setTenthRooms(pgInfo.NoOfRoomsinTenthFloor || "");
                    setTenthBeds(pgInfo.NoOfBedsInTenthFloor || "");
                    setOtherRooms(pgInfo.NoOfRoomsinAnyotherAreaFloor || "");
                    setOtherBeds(pgInfo.NoOfBedsInAnyAreaFloor || "");

                    const options = await fetchCompanyData("");
                    // console.log(options);
                    let defaultCompanyGroupObj = options?.find((company) => (company.label).includes(responseData.Company));
                    // console.log(defaultCompanyGroupObj);
                    let defaultRelationship = await api.getRelationship(defaultCompanyGroupObj?.value)
                    // console.log(defaultRelationship);

                    setSelectedCompany({
                        value: defaultCompanyGroupObj?.value,
                        label: defaultCompanyGroupObj?.label,
                    });

                    setSelectGroup({
                        value: defaultCompanyGroupObj?.groupId,
                        label: defaultCompanyGroupObj?.group,
                    });

                    console.log(defaultRelationship);

                    if (defaultRelationship.Response?.Data) {
                        let defaultRelationshipObj = defaultRelationship.Response?.Data?.find((relationship) => (relationship.Relationship_Name).includes(responseData.Relationship));
                        // console.log(defaultRelationshipObj);
                        setSelectRelationship({
                            value: defaultRelationshipObj?.Relationship_ID,
                            label: defaultRelationshipObj?.Relationship_Name
                        });
                    }
                    setCompanyOptions(options);
                    setOtcDiscount(responseData?.OTCDisocuntAmountB)
                    setRcDiscount(responseData?.RCDisocuntAmountB)
                    setOtcAmount(responseData?.OTCAmount)
                    setRcAmount(responseData?.RCAmount)
                    ///////////////////////////////////

                    setOpportunityData({
                        remark: responseData.Remarks || "",
                        Redunancy: responseData.Redunancy || false,
                        Block: responseData.Block || "",
                        Status: responseData.Status || "",
                        Statuscode: responseData.Statuscode || "",
                        OppId: responseData.OppId || "",
                        OppStatus: responseData.Statuscode || "",
                        LeadId: responseData.LeadId || "",
                        PriceList: responseData.PriceList || "",
                        Topic: responseData.Topic || "",
                        // StateId: responseData.StateId || "",
                        // CityId: responseData.CityId || "",
                        // AreaId: responseData.AreaId || "",
                        BuildingId: responseData.BuildingId || "",
                        SpecificArea: responseData.SpecificArea || "",
                        SpecificBuilding: responseData.SpecificBuilding || "",
                        Building_BuildingStatus: responseData.Building_BuildingStatus || "",
                        NoOfUsers: responseData.NoOfUsers || "",
                        NoOfBeds: responseData.NoOfBeds || "",
                        // IndustryId: responseData.IndustryId || "",
                        ApprovalRequiredFlag: responseData.ApprovalRequiredFlag || "",
                        Reason: responseData.Reason || "",
                        Area: responseData.Area || "",
                        Subbusinesssegment: responseData.Subbusinesssegment || "",
                        Businesssegment: responseData.Businesssegment || "",
                        // State: responseData.State || "",
                        // Salutation: responseData.Salutation || "",
                        Relationship: responseData.Relationship || "",
                        PostalCode: responseData.PostalCode || "",
                        Mobilephone: responseData.Mobilephone || "",
                        Media: responseData.Media || "",
                        Lco: responseData.Lco || null,
                        // Industry: responseData.Industry || "",
                        Group: responseData.Group || "",
                        Floor: responseData.Floor || "",
                        TPFeasibilty: responseData.TPFeasibilty || "",
                        CreateAreaOrBuilding: responseData.CreateAreaOrBuilding || false,
                        Firmtype: responseData.Firmtype || "",
                        Product: responseData.Product || "",
                        ProductSegment: responseData.ProductSegment || "",
                        FeasibilityRequired: responseData.FeasibilityRequired || false,
                        Existingprovider: responseData.Existingprovider || "",
                        Emailaddress: responseData.Emailaddress || "",
                        // Country: responseData.Country || "",
                        Companyname: responseData.Companyname || "",
                        // City: responseData.City || "",
                        leadname: responseData.leadname || "",
                        Buildingname: responseData.Buildingname || "",
                        BuildingNo: responseData.BuildingNo || "",
                        ContactPerson: responseData.ContactPerson || "",
                        CustomerSegment: responseData.CustomerSegment || "",
                        LastMileType: responseData.LastMileType || "",
                        UpTimesla: responseData.UpTimesla || "",
                        Firewall: responseData.Firewall || "",
                        // CompanySelf: responseData.CompanySelf || "",
                        PoLock: responseData.PoLock || "",
                        Price: responseData.Price || "",
                        OriginatingLead: responseData.OriginatingLead || "",
                        FirewallAwc: responseData.FirewallAwc || "",
                        PoNext: responseData.PoNext || "",
                        // Company: responseData.Company || "",
                        TotalAmount: responseData.TotalAmount || "",
                        VerticalID: responseData.VerticalID || "",
                        TypeOfOrder: responseData.TypeOfOrder || "",
                        PocClosureDate: responseData.PocClosureDate || "",
                        TurnOver: responseData.TurnOver || "",
                        SocietyName: responseData.SocietyName || "",
                        SocietyId: responseData.SocietyId || "",
                        SocietyStatus: responseData.SocietyStatus || "",
                        HousePlotFlatNo: responseData.HousePlotFlatNo || "",
                        BlockTowerNumber: responseData.BlockTowerNumber || "",
                        OTCAmount: responseData.OTCAmount || "",
                        SDAmount: responseData.SDAmount || "",
                        RCAmount: responseData.RCAmount || "",
                        sdDiscount: responseData.SDDiscountAmount || "",
                        otcDiscount: responseData.OTCDisocuntAmountB || "",
                        rcDiscount: responseData.RCDisocuntAmountB || "",
                        exOtcDiscount: responseData.OTCExtendedAmountB || "",
                        exSdDiscount: responseData.SDExtendedAmount || "",
                        exRcDiscount: responseData.RCExtendedAmountB || "",
                        pgName: pgInfo.PGName || "",
                        pgType: pgInfo.PGType || "",
                        tenantType: pgInfo.TenantType || "",
                        spectraRFS: pgInfo.SpectraRFS || "",
                        contactDesignation: pgInfo.Designation || "",
                        role: pgInfo.Role || "",
                        numberOfRooms: pgInfo.NumberofRooms || "",
                        numberOfBeds: pgInfo.NumberofBeds || "",
                        perBedRent: pgInfo.PerBedRent || "",
                        existingInternetProvider: pgInfo.ExistingInternetProvider || "",
                        existingInternetOutflow: pgInfo.ExistingInternetOutflowPerMonth || "",
                        currentInfra: pgInfo.CurrentInfra || "",
                        googleRatings: pgInfo.GoogleRatings || "",
                        pgInternetRatings: pgInfo.PGInternetRatings || "",
                        urgentTriggers: pgInfo.UrgentTriggers || "",
                        spectraRelationship: pgInfo.SpectraRelationship || "",
                        commonAreaName: pgInfo.CommonName || "",
                        paymentTerms: pgInfo.PaymentTerms,
                        DesignationOthers: pgInfo.DesignationOthers || "",
                        ExistingInternetProviderOther: pgInfo.ExistingInternetProviderOther || "",
                        ExistingInternetOutflowPerMonthOther: pgInfo.ExistingInternetOutflowPerMonthOther || "",
                        Latitude: pgInfo.Latitude || "",
                        Longitude: pgInfo.Longitude || "",
                        QuoteStatus: pgInfo.QuoteStatus || "",
                        // NumberofInternetUsers: pgInfo.NumberofInternetUsers || "",

                        // targetInstallationPeriod:
                        // data.Response[0].otherDetail.TargetInstallationPeriod,
                        painPoints: [
                            // pgInfo.PoorCustomerReviews === "1" && "poorCustomerReviews",
                            // pgInfo.TenantComplaints === "1" && "tenantComplaints",
                            // pgInfo.TenantChurn === "1" && "tenantChurn",
                            // pgInfo.PoorCustomerSupportfromexistingvendor === "1" && "poorCustomerSupport",
                            // pgInfo.MultipleVendors === "1" && "multipleVendors",
                            // pgInfo.NewBuilding === "1" && "newBuilding",

                            pgInfo.FrequentDowntime === "1" && "FrequentDowntime",
                            pgInfo.SpeedPerformance === "1" && "SpeedPerformance",
                            pgInfo.HighLatency === "1" && "HighLatency",
                            pgInfo.BillingDiscrepancies === "1" && "BillingDiscrepancies",
                            pgInfo.PoorServiceSupportSLAViolations === "1" && "PoorServiceSupportSLAViolations",
                            pgInfo.LimitedScalabilityUpgradeChallenges === "1" && "LimitedScalabilityUpgradeChallenges",
                            pgInfo.SecurityConcernsComplianceIssues === "1" && "SecurityConcernsComplianceIssues",
                            pgInfo.BadCoverageInfrastructureLimitations === "1" && "BadCoverageInfrastructureLimitations",
                            pgInfo.NoRedundancybackuplink === "1" && "NoRedundancybackuplink",
                            pgInfo.NoMonitoringUsageReport === "1" && "NoMonitoringUsageReport",
                        ].filter(Boolean),
                    });

                    const paymentoption = paymentoptions.find((opt) => opt.value === pgInfo.PaymentTerms) || null;
                    setselectPayment(paymentoption);

                    const defaultPainPointOptions = [];
                    // if (pgInfo.PoorCustomerReviews === "1")
                    //     painPointOptions.push({ value: "poorCustomerReviews", label: "Poor Customer Reviews" });
                    // if (pgInfo.TenantComplaints === "1")
                    //     painPointOptions.push({ value: "tenantComplaints", label: "Tenant Complaints" });
                    // if (pgInfo.TenantChurn === "1")
                    //     painPointOptions.push({ value: "tenantChurn", label: "Tenant Churn" });
                    // if (pgInfo.PoorCustomerSupportfromexistingvendor === "1")
                    //     painPointOptions.push({
                    //         value: "poorCustomerSupport",
                    //         label: "Poor Customer Support from existing vendor",
                    //     });
                    // if (pgInfo.MultipleVendors === "1")
                    //     painPointOptions.push({ value: "multipleVendors", label: "Multiple Vendors" });
                    // if (pgInfo.NewBuilding === "1")
                    //     painPointOptions.push({ value: "newBuilding", label: "New Building" });

                    if (pgInfo.FrequentDowntime === "1") { defaultPainPointOptions.push(painPointOptions.find((data) => data.value == "FrequentDowntime")); }
                    if (pgInfo.SpeedPerformance === "1") { defaultPainPointOptions.push(painPointOptions.find((data) => data.value == "SpeedPerformance")); }
                    if (pgInfo.HighLatency === "1") { defaultPainPointOptions.push(painPointOptions.find((data) => data.value == "HighLatency")); }
                    if (pgInfo.BillingDiscrepancies === "1") { defaultPainPointOptions.push(painPointOptions.find((data) => data.value == "BillingDiscrepancies")); }
                    if (pgInfo.PoorServiceSupportSLAViolations === "1") { defaultPainPointOptions.push(painPointOptions.find((data) => data.value == "PoorServiceSupportSLAViolations")); }
                    if (pgInfo.LimitedScalabilityUpgradeChallenges === "1") { defaultPainPointOptions.push(painPointOptions.find((data) => data.value == "LimitedScalabilityUpgradeChallenges")); }
                    if (pgInfo.BadCoverageInfrastructureLimitations === "1") { defaultPainPointOptions.push(painPointOptions.find((data) => data.value == "BadCoverageInfrastructureLimitations")); }
                    if (pgInfo.NoRedundancybackuplink === "1") { defaultPainPointOptions.push(painPointOptions.find((data) => data.value == "NoRedundancybackuplink")); }
                    if (pgInfo.NoMonitoringUsageReport === "1") { defaultPainPointOptions.push(painPointOptions.find((data) => data.value == "NoMonitoringUsageReport")); }

                    setSelectPainPoints(defaultPainPointOptions);

                    const selected = [];
                    if (pgInfo.BasementCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Basement"));
                    }
                    if (pgInfo.GroundFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Ground"));
                    }
                    if (pgInfo.FirstFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "First"));
                    }
                    if (pgInfo.SecondFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Second"));
                    }
                    if (pgInfo.ThirdFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Third"));
                    }
                    if (pgInfo.FourthFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Fourth"));
                    }
                    if (pgInfo.FifthFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Fifth"));
                    }
                    if (pgInfo.SixthFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Sixth"));
                    }
                    if (pgInfo.SeventhFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Seventh"));
                    }
                    if (pgInfo.EighthFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Eighth"));
                    }
                    if (pgInfo.NinthFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Ninth"));
                    }
                    if (pgInfo.TenthFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Tenth"));
                    }
                    if (pgInfo.AnyAreaFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Other"));
                    }

                    // Update selectedFloors state with the array of selected options
                    setSelectedFloors(selected);
                    setOtcAmountDis(responseData.OTCDiscountAmount);
                    setRcAmountDis(responseData.RCAmount);
                    setOtcAmount(responseData.OTCAmount);
                    setSdAmount(responseData.SDAmount);
                    setleadid(responseData.LeadId);
                    // setSelectedPriceList(responseData.PriceList);
                    // console.log("responseData.Product", responseData.Product)
                    setStatusCode(responseData.Statuscode);
                    setStatus(responseData.Status);
                    setSelectSociety(responseData.SocietyName);

                    setSelectedFirmType(firmtype.find(item => item.value === responseData.Firmtype));
                    setSelectedMedia(media.find(item => item.value === responseData.Media));
                    setSelectExServiceProvider1(ExServiceProvider.find(item => item.value === responseData.Existingprovider));
                    setSelectInterestedFirewall(optionInterestedFirewall.find(item => item.value === responseData.Firewall));
                    setSelectInteretedVPN(optionInterestedVPN.find(item => item.value === responseData.Redunancy));
                    setSelectInterestedManageWiFi(optionInterestedManageWiFi.find(item => item.value === responseData.CompanySelf));

                    // console.log(ExServiceProvider.find(item => item.value === responseData.Existingprovider));

                    let getBuilding = await api.getBuilding({ areaName: responseData.AreaId, areaCode: responseData?.AreaId })


                    let defaultBuilding = getBuilding?.Response?.Data?.find((building) => building.BuildingCode == responseData?.BuildingId)
                    if (defaultBuilding) {
                        // console.log(defaultBuilding);
                        setSelectBuilding({
                            value: defaultBuilding.BuildingCode,
                            label: defaultBuilding.BuildingName
                        })
                    }

                    setSelectedProduct({
                        value: responseData.Product,
                        label: responseData.Product,
                    });

                    setSelectedPriceList(
                        {
                            value: responseData.PriceList,
                            label: responseData.PriceList,
                        }
                    )
                    setSelectCountry({
                        value: responseData.Country,
                        label: responseData.Country,
                    });
                    setSelectState({
                        value: responseData.StateId,
                        label: responseData.State,
                    })
                    setSelectCity({
                        value: responseData.CityId,
                        label: responseData.City,
                    })
                    setSelectArea({
                        value: responseData.AreaId,
                        label: responseData.Area,
                    })


                    const filterCustomerSegment = optionCustomerSeg.find(item => item.value === String(responseData.CustomerSegment))?.label;


                    setSelectCustomerSeg(
                        {
                            value: responseData.CustomerSegment,
                            label: filterCustomerSegment,
                        });
                    // console.log("responseData.TurnOver",responseData.TurnOver);

                    const filterTurnOver = optionTurnOver?.find(item => item.value === String(responseData?.TurnOver))?.label;
                    // console.log("filterTurnOver",filterTurnOver);

                    setSelectTurnOver(
                        {
                            value: responseData.TurnOver,
                            label: filterTurnOver,
                        });
                    const filterSalutationId = optionSolutation.find(
                        (item) => item.value === String(responseData.Salutation)
                    ).label;
                    setSelectSolutaton({
                        value: responseData.Salutation,
                        label: filterSalutationId,
                    });
                    setSelectIndustry({
                        value: responseData.IndustryId,
                        label: responseData.Industry,
                    })
                    // console.log(companyOptions);

                    // if (responseData?.Company) {
                    //   setSelectedCompany({
                    //     value: responseData.Company,
                    //     label: responseData.Company,
                    //   });
                    // }

                    //////////////
                    // console.log(responseData?.ProductSegment, responseData?.Building_BuildingStatus, responseData?.Redunancy, responseData?.InfraFlag);

                    // if ((segment == "BIA" || segment == "ILL") && BuildingStatus == "Non-RFS") {
                    //   generateFeasibilityBtn(true)
                    //   isRedundancyLocked(false)
                    // }
                    // if ((segment == "BIA" || segment == "ILL") && BuildingStatus !== "Non-RFS") {
                    //   generateFeasibilityBtn(false)
                    //   isRedundancyLocked(true)
                    // }
                    // if ((segment == "MBIA" || segment == "MBB") && RedundancyRequired == "YES") {
                    //   generateFeasibilityBtn(true)
                    //   isRedundancyLocked(false)
                    // }
                    // if (segment == "MS WiFi" && RedundancyRequired == "YES" && InfraFlag !== YES) {
                    //   generateFeasibilityBtn(true)
                    //   isRedundancyLocked(false)
                    // }
                    // if (segment == "MS WiFi" && RedundancyRequired == "YES" && InfraFlag == YES) {
                    //   generateFeasibilityBtn(false)
                    //   isRedundancyLocked(true)
                    // }

                } else {
                    console.error("Error fetching opportunity data:", responseData?.Message);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    // useEffect(() => {
    //   const loadOptions = async () => {
    //     const options = await fetchCompanyData("");
    //     console.log(options);
    //     let defaultCompanyGroupObj = options?.find((company) => (company.label).includes(opportunityData.Company));
    //     console.log(defaultCompanyGroupObj);
    //     let defaultRelationship = await api.getRelationship(defaultCompanyGroupObj?.value)
    //     console.log(defaultRelationship);

    //     setSelectedCompany({
    //       value: defaultCompanyGroupObj?.value,
    //       label: defaultCompanyGroupObj?.label,
    //     });

    //     setSelectGroup({
    //       value: defaultCompanyGroupObj?.groupId,
    //       label: defaultCompanyGroupObj?.group,
    //     });

    //     // console.log(defaultRelationship);

    //     if (defaultRelationship.Response?.length > 0) {
    //       let defaultRelationshipObj = defaultRelationship.Response?.find((relationship) => (relationship.Relationship_ID).includes(opportunityData.Relationship));
    //       console.log(defaultRelationshipObj);
    //       setSelectRelationship({
    //         value: defaultRelationshipObj?.Relationship_ID,
    //         label: defaultRelationshipObj?.Relationship_Name
    //       });
    //     }

    //     setCompanyOptions(options);

    //   };
    //   loadOptions();
    // }, []);

    const handleWon = async () => {
        //  console.log(selectedProduct.value);
        const requiredField = {
            // "Topic": opportunityData.Topic ? opportunityData.Topic : "",
            "Block": opportunityData.Block || "",
            // "Building": true,
            "Area": selectArea.value || "",
            "BuildingNo": opportunityData.BuildingNo || "",
            "Buildingname": selectBuilding.value || "",
            "City": selectCity?.value ? selectCity.value : "",
            // "Company Self": selectInterestedManageWiFi?.value || "",
            "Contact Person": opportunityData.ContactPerson ? opportunityData.ContactPerson : "",
            "Country": "10001",
            // "Customer Segment": selectCustomerSeg.value ? selectCustomerSeg.value : "",
            "Email address": opportunityData.Emailaddress ? opportunityData.Emailaddress : "",
            // "Existin gprovider": selectExServiceProvider1.value || "",
            // "Firewall": selectInterestedFirewall?.value || "",
            // "Firmtype": selectedFirmType.value || "",
            "Floor": opportunityData.Floor ? opportunityData.Floor : "",
            "Industry": selectIndustry.value ? selectIndustry.value : "",
            "Media": selectedMedia.value || "",
            "Mobilephone": opportunityData.Mobilephone ? opportunityData.Mobilephone : "",
            // oppId: OppId ? OppId : "",
            // "PO Lock": yyyymmddFormat(opportunityData.PoLock) || "",
            // "PO Next": yyyymmddFormat(opportunityData.PoNext) || "",
            "Postal Code": opportunityData.PostalCode ? opportunityData.PostalCode : "",
            // "Price List": selectedPriceList.value ? selectedPriceList.value : "",
            // reason: opportunityData.Reason ? opportunityData.Reason : "",
            // "Redunancy": typeof (selectInterestedVPN?.value) === "boolean" ? selectInterestedVPN?.value : "",  // selectInterestedVPN.value,
            "Salutation": selectSolutaton.value ? selectSolutaton.value : "",
            // specificArea: opportunityData.SpecificArea || "",
            // specificBuilding: opportunityData.SpecificBuilding || "",
            "State": selectState.value ? selectState.value : "",
            // "Turn Over": selectTurnOver.value ? selectTurnOver.value : "",
            // typeOfOrder: "",
            // "UpTime SLA": opportunityData.UpTimesla || "",
        }

        // console.log(requiredField);

        if (!checkRequiredFields(requiredField)) { return }


        try {
            setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestData = {
                Action: "wonOpportunity",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                oppid: OppId,
                password: sessionStorage.getItem('password'),
                reason: "",
                siteId: "",
                userName: sessionStorage.getItem('userName'),
            };
            // console.log(requestData);return


            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });

            const data = await response.json();
            // console.log(data);

            // Check for a successful API response
            if (data.Response.StatusCode === 200) {
                toast.success("Opportunity marked as Won", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });

                setTimeout(() => {
                    window.location.reload();
                }, 1500);

            } else {
                toast.warning(data.Response.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });

            }
        } catch (error) {
            console.error("Error during API call:", error);
        } finally {
            setLoading(false);
        }

    };




    const handleSendToApproval = () => {
        try {
            Swal.fire({
                title: '<div style="font-size: 22px; margin-top:5px;">Action Required</div>',
                text: "Please submit for approval as discount added in OTC or RC amount",
                confirmButtonText:
                    '<span style="font-size: 15px;">Submit for Approval</span>',
                confirmButtonColor: "rgb(148,101,170)",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const { value: formValues } = await Swal.fire({
                        title: `<div style="font-size: 15px;padding: 10px;">Enter Reason for Discount</div>`,
                        // html: `<div style="font-size: 15px;">Reason of Payment DOA</div>`,
                        html: `
                                              <input id="swal-input1" class="swal2-input">  `,
                        focusConfirm: false,
                        preConfirm: () => {
                            // return [document.getElementById("swal-input1").value];
                            const reason = document.getElementById("swal-input1").value.trim();
                            if (!reason) {
                                Swal.showValidationMessage("Reason is required.");
                                return;
                            }
                            return reason;
                        }
                    });
                    if (formValues) {
                        const ApiUrl = process.env.REACT_APP_API_URL;
                        const requestBody = {
                            "Action": "createApproval",
                            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                            "userName": sessionStorage.getItem('userName'),
                            "password": sessionStorage.getItem('password'),
                            "oppid": OppId ? OppId : "",
                            "reason": formValues
                        };
                        const Response = await fetch(ApiUrl, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(requestBody),
                        });
                        const data = await Response.json();
                        // console.log(data)
                        if (data.Status == "Success") {
                            toast.success(data.Response.Message, {
                                position: toast.POSITION.BOTTOM_CENTER,
                                autoClose: 1500,
                            });
                            window.location.reload()
                        }
                    }
                }
            })
        }
        catch (error) {
            console.error("Error during API call:", error);
        }
    }


    const checkRequiredFields = (payload) => {
        for (const key in payload) {
            // console.log(key, ":", payload[key]);

            if (payload[key] === "" || payload[key] === null) {
                // console.log(payload[key]);
                toast.error(`Required field: ${key}`, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                return false; // Stop execution if any field is empty
            }
        }
        return true; // All fields are valid
    };


    useEffect(() => {
        if (totalEmpCount && totalCarpetArea) {
            const empCount = totalEmpCount;
            const areaSqft = totalCarpetArea;

            if (!isNaN(empCount) && !isNaN(areaSqft)) {
                if ((empCount <= 29 && areaSqft <= 599) && (selectDoesCustNeedStaticIP.value == "111260001" || !selectDoesCustNeedStaticIP)) {
                    setSelectContactFor({ label: "SOHO", value: "4" });
                    // setSelectIndustry({ value: "IND_0074_ID", label: "ProFi SOHO" });
                }
                // If officeEmpCount > 30, then Officeareasqft should be > 700 -> Office
                else if ((empCount >= 30 && empCount <= 100) && (areaSqft >= 600 && areaSqft <= 4500) && (selectDoesCustNeedStaticIP.value == "111260001" || !selectDoesCustNeedStaticIP)) {
                    setSelectContactFor({ label: "Office", value: "2" });
                    // setSelectIndustry('');
                }
                else if ((empCount >= 1 && empCount <= 100) && (areaSqft >= 1 && areaSqft <= 4500) && selectDoesCustNeedStaticIP.value == "111260000") {
                    setSelectContactFor({ label: "Business Value", value: "5" });
                    // setSelectIndustryType('');
                }
                // else{
                //     setSelectContactFor("");
                // }
                else if (empCount <= 29 && areaSqft > 599) {
                    setSelectContactFor("");
                } else if (empCount > 29 && areaSqft <= 599) {
                    setSelectContactFor("");
                }
            }
        }
    }, [totalEmpCount, totalCarpetArea, selectDoesCustNeedStaticIP.value]);


    const handleEmpCountAndAreaBlur = () => {
        if (totalEmpCount && totalCarpetArea) {
            const empCount = parseInt(totalEmpCount, 10);
            const areaSqft = parseInt(totalCarpetArea, 10);

            if (!isNaN(empCount) && !isNaN(areaSqft)) {
                if (empCount <= 29 && areaSqft <= 599) {
                    toast.warning("Opportunity has been selected for ProFi SoHo based on Internet Users and Carpet Area.", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 3000 });
                }
                else if ((empCount >= 30 && empCount <= 100) && (areaSqft >= 600 && areaSqft <= 4500) && (selectDoesCustNeedStaticIP.value == "111260001" || !selectDoesCustNeedStaticIP)) {
                    toast.warning("Opportunity has been selected for ProFi Office based on Internet Users and Carpet Area.", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 3000 });
                }
                else if ((empCount >= 1 && empCount <= 100) && (areaSqft >= 1 && areaSqft <= 4500) && selectDoesCustNeedStaticIP.value == "111260000") {
                    toast.warning("Lead has been selected for ProFi Business value.", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 3000 });
                }
            }
        }
    };



    const handleUpdateOpportunity = async (event) => {
        try {
            const area = Number(totalCarpetArea);
            const employees = Number(totalEmpCount);

            const isAreaValid = area >= 600 && area <= 4500;
            const isEmployeeValid = employees >= 30 && employees <= 100;

            const isAreaValidSoho = area >= 1 && area <= 599;
            const isEmployeeValidSoho = employees >= 1 && employees <= 29;

            if (!isNaN(employees) && !isNaN(area)) {
                // Profi SoHo: Users 1-29, Area 1-599 Sq.Ft
                if ((employees >= 1 && employees <= 29) && (selectDoesCustNeedStaticIP?.value == "111260001")) {
                    if ((area < 1 || area > 599) && (selectDoesCustNeedStaticIP?.value == "111260001")) {
                        toast.warning(
                            "For 1-29 users, Office Sitting Area (sqft) must be between 1 and 599.",
                            { position: toast.POSITION.BOTTOM_CENTER, autoClose: 3500 }
                        );
                        setTotalCarpetArea("");
                        return;
                    }
                }
                // Profi Office: Users 30-100, Area 600-4500 Sq.Ft
                else if ((employees >= 30 && employees <= 100) && (selectDoesCustNeedStaticIP?.value == "111260001")) {
                    if ((area < 600 || area > 4500) && (selectDoesCustNeedStaticIP?.value == "111260001")) {
                        toast.warning(
                            "For 30-100 users, Office Sitting Area (sqft) must be between 600 and 4500.",
                            { position: toast.POSITION.BOTTOM_CENTER, autoClose: 3500 }
                        );
                        setTotalCarpetArea("");
                        return;
                    }
                }
                // Profi Business Value: Users 1-100, Area 1-4500 Sq.Ft
                else if ((employees > 1 && employees <= 100) && (selectDoesCustNeedStaticIP?.value == "111260000")) {
                    if ((area < 1 || area > 4500) && (selectDoesCustNeedStaticIP?.value == "111260000")) {
                        toast.warning(
                            "For 1-100 users, Office Sitting Area (sqft) must be between 1 and 4500.",
                            { position: toast.POSITION.BOTTOM_CENTER, autoClose: 3500 }
                        );
                        setTotalCarpetArea("");
                        return;
                    }
                }
                // Users outside the valid range
                else if (employees < 1 || employees > 100) {
                    toast.warning(
                        "Internet Users (count) must be between 1 and 100.",
                        { position: toast.POSITION.BOTTOM_CENTER, autoClose: 3500 }
                    );
                    setTotalEmpCount("");
                    return;
                }
            }

            // if (selectContactFor.value == "4") {
            //     if (!isAreaValidSoho) {
            //         toast.warning("Carpet Area must be between 1 and 599 sq.ft", {
            //             position: toast.POSITION.BOTTOM_CENTER,
            //             autoClose: 2000,
            //         }
            //         );
            //         return;
            //     }
            //     if (!isEmployeeValidSoho) {
            //         toast.warning("Employee count must be between 1 and 29", {
            //             position: toast.POSITION.BOTTOM_CENTER,
            //             autoClose: 2000,
            //         }
            //         );
            //         return;
            //     }
            // }

            if (selectContactFor.value == "2" || selectContactFor.value == "5") {
                if (!noOfUnit || noOfUnit == 0) {
                    toast.warning("Number of Unit must be selected", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    }
                    );
                    return;
                }

                if (!isAreaValid && selectDoesCustNeedStaticIP?.value == "111260001") {
                    toast.warning("Office area must be between 600 and 4500 sq.ft", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    }
                    );
                    return;
                }
                if (!isEmployeeValid && selectDoesCustNeedStaticIP?.value == "111260001") {
                    toast.warning("Employee count must be between 30 and 100", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    }
                    );
                    return;
                }
            }

            if (noOfUnit == 1) {
                if (!firstFloor && specialFloorOne.value == "") {
                    toast.warning("Unit 1 floor or special floor must be entered/selected", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                    return;
                }

                if (!carpetAreaOne) {
                    toast.warning("Unit 1 Carpet Area must be entered", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                    return;
                }

                if (!empCountOne) {
                    toast.warning("Unit 1 employee count must be entered", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                    return;
                }


            }

            if (noOfUnit == 2) {
                if (!firstFloor && specialFloorOne.value == "") {
                    toast.warning("Unit 1 floor or special floor must be entered/selected", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                    return;
                }

                if (!carpetAreaOne) {
                    toast.warning("Unit 1 Carpet Area must be entered", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                    return;
                }

                if (!empCountOne) {
                    toast.warning("Unit 1 employee count must be entered", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                    return;
                }

                if (!secondFloor && specialFloorTwo.value == "") {
                    toast.warning("Unit 2 floor or special floor must be entered/selected", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                    return;
                }
                if (!carpetAreaTwo) {
                    toast.warning("Unit 2 Carpet Area must be entered", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                    return;
                }

                if (!empCountTwo) {
                    toast.warning("Unit 2 employee count must be entered", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                    return;
                }
            }


            if (noOfUnit == 3) {
                if (!firstFloor && specialFloorOne.value == "") {
                    toast.warning("Unit 1 floor or special floor must be entered/selected", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                    return;
                }

                if (!carpetAreaOne) {
                    toast.warning("Unit 1 Carpet Area must be entered", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                    return;
                }

                if (!empCountOne) {
                    toast.warning("Unit 1 employee count must be entered", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                    return;
                }

                if (!secondFloor && specialFloorTwo.value == "") {
                    toast.warning("Unit 2 floor or special floor must be entered/selected", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                    return;
                }
                if (!carpetAreaTwo) {
                    toast.warning("Unit 2 Carpet Area must be entered", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                    return;
                }

                if (!empCountTwo) {
                    toast.warning("Unit 2 employee count must be entered", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                    return;
                }

                if (!thirdFloor && specialFloorThree.value == "") {
                    toast.warning("Unit 3 floor or special floor must be entered/selected", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                    return;
                }



                if (!carpetAreaThree) {
                    toast.warning("Unit 3 Carpet Area must be entered", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                    return;
                }

                if (!empCountThree) {
                    toast.warning("Unit 3 employee count must be entered", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                    return;
                }
            }

            if (!selectDoesCustNeedStaticIP?.value) {
                toast.warning("Select does customer need static IP", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                return;
            }

            setLoading(true);
            event.preventDefault(); // Prevent default submission

            if (selectExistingInternetProvider?.value == "111260005") {
                if (!opportunityData?.ExistingInternetProviderOther) {
                    toast.error("Please enter specific internet provider.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    setLoading(false);
                    return;
                }
            }

            if (selectExistingInternetOutflow?.value == "111260007") {
                if (!opportunityData?.ExistingInternetOutflowPerMonthOther) {
                    toast.error("Please enter specific internet out flow per month.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    setLoading(false);
                    return;
                }
            }

            if (selectContactDesignation?.label == "Other") {
                if (!opportunityData?.DesignationOthers) {
                    toast.error("Please enter specific designation.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    setLoading(false);
                    return;
                }
            }



            const requiredField = {
                "Topic": opportunityData.Topic ? opportunityData.Topic : "",
                "Block": opportunityData.Block || "",
                "Area": selectArea.value || "",
                "BuildingNo": opportunityData.BuildingNo || "",
                "Buildingname": selectBuilding.value || "",
                "City": selectCity?.value ? selectCity.value : "",
                "Contact Person": opportunityData.ContactPerson ? opportunityData.ContactPerson : "",
                "Country": "10001",
                "Email address": opportunityData.Emailaddress ? opportunityData.Emailaddress : "",
                "Floor": opportunityData.Floor ? opportunityData.Floor : "",
                "Industry": selectIndustry.value ? selectIndustry.value : "",
                "Mobilephone": opportunityData.Mobilephone ? opportunityData.Mobilephone : "",
                "Postal Code": opportunityData.PostalCode ? opportunityData.PostalCode : "",
                "Salutation": selectSolutaton.value ? selectSolutaton.value : "",
                "State": selectState.value ? selectState.value : "",

                "Barriers": barriers?.value || "",
                "Applications": applications?.value || "",
                "Company Turnover": companyTurnover?.value || "",


            }

            // console.log(requiredField);
            if (!checkRequiredFields(requiredField)) { return }


            setLoader(true)

            const UnitsSection = [];
            if (selectContactFor.value == "2" || selectContactFor.value == "5") {
                for (let i = 0; i < noOfUnit; i++) {
                    UnitsSection.push({
                        UnitNo: `${i + 1}`,
                        Floor: i === 0 ? firstFloor : i === 1 ? secondFloor : thirdFloor,
                        CarepetArea: i === 0 ? carpetAreaOne : i === 1 ? carpetAreaTwo : carpetAreaThree,
                        EmployeeCount: i === 0 ? empCountOne : i === 1 ? empCountTwo : empCountThree,
                        SpecialFloors: i === 0 ? specialFloorOne.value : i === 1 ? specialFloorTwo.value : specialFloorThree.value,
                    });
                }
            }
            const apiUrl = process.env.REACT_APP_API_URL
            const payload = {
                Action: "updateopportunityBBDIA",  // "updateopportunity",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                Remarks: opportunityData.remark,
                block: opportunityData.Block || "",
                createAreaOrBuilding: true,
                firewallAwc: yyyymmddFormat(opportunityData?.FirewallAMCExpiryDate) || "",
                pocClosureDate: "",
                area: selectArea.value || "",
                buildingNo: opportunityData.BuildingNo || "",
                buildingname: selectBuilding.value || "",
                city: selectCity.value ? selectCity.value : "",
                companySelf: selectInterestedManageWiFi?.value || "",
                contactPerson: opportunityData.ContactPerson ? opportunityData.ContactPerson : "",
                country: "10001",
                customerSegment: selectCustomerSeg.value ? selectCustomerSeg.value : "111260000",
                emailaddress: opportunityData.Emailaddress ? opportunityData.Emailaddress : "",
                existingprovider: selectExServiceProvider1.value || "",
                firewall: selectInterestedFirewall?.value || "",
                firmtype: selectedFirmType.value || "",
                floor: opportunityData.Floor ? opportunityData.Floor : "",
                industry: selectIndustry.value ? selectIndustry.value : "",
                lco: "",
                media: selectedMedia?.value || "",
                mobilephone: opportunityData.Mobilephone ? opportunityData.Mobilephone : "",
                noOfBeds: "",
                noOfUsers: "",
                oppId: OppId ? OppId : "",
                poLock: yyyymmddFormat(opportunityData.PoLock) || "",
                poNext: yyyymmddFormat(opportunityData.PoNext) || "",
                postalCode: opportunityData.PostalCode ? opportunityData.PostalCode : "",
                priceList: selectedPriceList.value ? selectedPriceList.value : "",
                reason: opportunityData.Reason ? opportunityData.Reason : "",
                redunancy: selectInterestedVPN?.value ? selectInterestedVPN?.value : false,
                salutation: selectSolutaton.value ? selectSolutaton.value : "",
                specificArea: opportunityData.SpecificArea || "",
                specificBuilding: opportunityData.SpecificBuilding || "",
                state: selectState.value ? selectState.value : "",
                topic: opportunityData.Topic ? opportunityData.Topic : "",
                turnOver: selectTurnOver.value ? selectTurnOver.value : "111260003",
                typeOfOrder: "",
                upTimesla: opportunityData.UpTimesla || "",
                societyId: opportunityData.SocietyId || "",
                housePlotFlatNo: opportunityData.HousePlotFlatNo ? opportunityData.HousePlotFlatNo : "",
                blockTowerNumber: opportunityData.BlockTowerNumber ? opportunityData.BlockTowerNumber : "",
                otcAmount: opportunityData.OTCAmount ? opportunityData.OTCAmount : "",
                sdAmount: opportunityData.SDAmount ? opportunityData.SDAmount : "",
                // otcAmountDis: opportunityData.otcDiscount ? opportunityData.otcDiscount : "",
                // OTCDiscountAmount: opportunityData.otcDiscount ? opportunityData.otcDiscount : "",
                // sdAmountDis: opportunityData.sdDiscount ? opportunityData.sdDiscount : "",
                // RCDiscountAmount: opportunityData.rcDiscount ? opportunityData.rcDiscount : "",
                password: sessionStorage.getItem('password'),
                userName: sessionStorage.getItem('userName'),
                SDWANOpp: {
                    firewallSetToExpire: "",
                    mPLSContract: "",
                    applicationsHosted: "",
                    currentOperationalCity: "",
                    customerBroadbandServices: "",
                    customerILLservices: "",
                    customerRoutingServices: "No",
                    indicationITSpent: "",
                    itSupport: "",
                    linksManagedLinks: "",
                    mPLSBackbone: "",
                    networkSecurityServices: "",
                    noOfLocation: "",
                    numberOfLinksBroadbandServices: "",
                    numberOfLinksIll: "",
                    redundancyMPLS: "",
                    sdwanRemarks: ""
                },
                PGInfo: {
                    "doesthecustomerneedastaticip": selectDoesCustNeedStaticIP?.value ? selectDoesCustNeedStaticIP?.value : "",
                    ContactFor: selectContactFor?.value ? selectContactFor.value : "",
                    PGType: "", // selectPGType ? selectPGType.value : opportunityData.pgType,
                    TenantType: "", // selectTenantType ? selectTenantType.value : opportunityData.tenantType,
                    Designation: selectContactDesignation ? selectContactDesignation.value : opportunityData.contactDesignation,
                    DesignationOthers: opportunityData.DesignationOthers || "", // update if you capture a value for this field
                    Role: selectRole ? selectRole.value : opportunityData.role,
                    NumberofRooms: opportunityData.numberOfRooms || "",
                    NumberofBeds: opportunityData.numberOfBeds || "",
                    PerBedRent: opportunityData.perBedRent || "",
                    ExistingInternetProvider: selectExistingInternetProvider
                        ? selectExistingInternetProvider.value
                        : opportunityData.existingInternetProvider,
                    ExistingInternetProviderOther: opportunityData.ExistingInternetProviderOther || "", // update if needed
                    ExistingInternetOutflowPerMonth: selectExistingInternetOutflow
                        ? selectExistingInternetOutflow.value
                        : opportunityData.existingInternetOutflow,
                    ExistingInternetOutflowPerMonthOther: opportunityData.ExistingInternetOutflowPerMonthOther || "", // update if needed
                    CurrentInfra: selectCurrentInfra ? selectCurrentInfra.value : opportunityData.currentInfra,
                    CurrentInfraOther: "", // update if needed
                    GoogleRatings: opportunityData.googleRatings || "",
                    PGInternetRatings: opportunityData.pgInternetRatings || "",
                    PoorCustomerReviews: opportunityData.painPoints?.includes("poorCustomerReviews") ? "1" : "0",
                    TenantComplaints: opportunityData.painPoints?.includes("tenantComplaints") ? "1" : "0",
                    TenantChurn: opportunityData.painPoints?.includes("tenantChurn") ? "1" : "0",
                    PoorCustomerSupportfromexistingvendor: opportunityData.painPoints?.includes("poorCustomerSupport") ? "1" : "0",
                    MultipleVendors: opportunityData.painPoints?.includes("multipleVendors") ? "1" : "0",
                    NewBuilding: opportunityData.painPoints?.includes("newBuilding") ? "1" : "0",
                    UrgentTriggers: selectUrgentTriggers ? selectUrgentTriggers.value : opportunityData.urgentTriggers || "",
                    SpectraRelationship: selectSpectraRelationship ? selectSpectraRelationship.value : opportunityData.spectraRelationship || "",
                    TotalNumberofFloors: totalFloors || "",
                    PaymentTerms: selectPayment?.value || "",

                    CommonArea: commonArea ? commonArea.value : "",
                    CommonName: opportunityData.commonAreaName || "", // if you capture a common area name
                    Elevator: elevator ? elevator.value : "",
                    ElevatorCount: opportunityData.elevatorCount || "", // update if you capture an elevator count
                    // Floor coverage flags

                    BasementCoverageRequired: floorCoverage.Basement,
                    GroundFloorCoverageRequired: floorCoverage.Ground,
                    FirstFloorCoverageRequired: floorCoverage.First,
                    SecondFloorCoverageRequired: floorCoverage.Second,
                    ThirdFloorCoverageRequired: floorCoverage.Third,
                    FourthFloorCoverageRequired: floorCoverage.Fourth,
                    FifthFloorCoverageRequired: floorCoverage.Fifth,
                    SixthFloorCoverageRequired: floorCoverage.Sixth,
                    SeventhFloorCoverageRequired: floorCoverage.Seventh,
                    EighthFloorCoverageRequired: floorCoverage.Eighth,
                    NinthFloorCoverageRequired: floorCoverage.Ninth,
                    TenthFloorCoverageRequired: floorCoverage.Tenth,
                    AnyAreaFloorCoverageRequired: floorCoverage.Other,
                    // Floor-specific room counts
                    NoOfRoomsinBasement: basementRooms,
                    NoOfRoomsinGroundFloor: groundRooms,
                    NoOfRoomsinFirstFloor: firstRooms,
                    NoOfRoomsinSecondFloor: secondRooms,
                    NoOfRoomsinThirdFloor: thirdRooms,
                    NoOfRoomsinFourthFloor: fourthRooms,
                    NoOfRoomsinFifthFloor: fifthRooms,
                    NoOfRoomsinSixthFloor: sixthRooms,
                    NoOfRoomsinSeventhFloor: seventhRooms,
                    NoOfRoomsinEighthFloor: eighthRooms,
                    NoOfRoomsinNinthFloor: ninthRooms,
                    NoOfRoomsinTenthFloor: tenthRooms,
                    NoOfRoomsinAnyotherAreaFloor: otherRooms,
                    // Floor-specific bed counts
                    NoOfBedsInBasement: basementBeds,
                    NoOfBedsInGroundFloor: groundBeds,
                    NoOfBedsInFirstFloor: firstBeds,
                    NoOfBedsInSecondFloor: secondBeds,
                    NoOfBedsInThirdFloor: thirdBeds,
                    NoOfBedsInFourthFloor: fourthBeds,
                    NoOfBedsInFifthFloor: fifthBeds,
                    NoOfBedsInSixthFloor: sixthBeds,
                    NoOfBedsInSeventhFloor: seventhBeds,
                    NoOfBedsInEightFloor: eighthBeds, // API field: "NoOfBedsInEightFloor"
                    NoOfBedsInNinthFloor: ninthBeds,
                    NoOfBedsInTenthFloor: tenthBeds,
                    NoOfBedsInAnyAreaFloor: otherBeds,

                    // --ProWifi--
                    ExistingConnectivity: existingConnectivity?.value || "",
                    Barriers: barriers?.value || "",
                    // NumberofInternetUsers: opportunityData.NumberofInternetUsers || "",
                    // OfficeArea: officeArea?.value || "",
                    // ProductName: productName?.value || "",
                    Applications: applications?.value || "",
                    CompanyTurnover: companyTurnover?.value || "",

                    EmployeeCount: officeEmployeeCount?.value || "",
                    OfficeArea: coverageAreaRange?.value || "",
                    NumberOfAccessPoints: accessPointsCount?.value || "",
                    // ProductName: planName?.value || "",

                    "FrequentDowntime": opportunityData.painPoints?.includes("FrequentDowntime") ? "1" : "0",
                    "SpeedPerformance": opportunityData.painPoints?.includes("SpeedPerformance") ? "1" : "0",
                    "HighLatency": opportunityData.painPoints?.includes("HighLatency") ? "1" : "0",
                    "BillingDiscrepancies": opportunityData.painPoints?.includes("BillingDiscrepancies") ? "1" : "0",
                    "PoorServiceSupportSLAViolations": opportunityData.painPoints?.includes("PoorServiceSupportSLAViolations") ? "1" : "0",
                    "LimitedScalabilityUpgradeChallenges": opportunityData.painPoints?.includes("LimitedScalabilityUpgradeChallenges") ? "1" : "0",
                    "SecurityConcernsComplianceIssues": opportunityData.painPoints?.includes("SecurityConcernsComplianceIssues") ? "1" : "0",
                    "BadCoverageInfrastructureLimitations": opportunityData.painPoints?.includes("BadCoverageInfrastructureLimitations") ? "1" : "0",
                    "NoRedundancybackuplink": opportunityData.painPoints?.includes("NoRedundancybackuplink") ? "1" : "0",
                    "NoMonitoringUsageReport": opportunityData.painPoints?.includes("NoMonitoringUsageReport") ? "1" : "0",

                    "OfficeArea": totalCarpetArea ? totalCarpetArea : "",
                    "EmployeeCount": totalEmpCount ? totalEmpCount : "",
                    "NoOfUnits": (selectContactFor.value == "2" || selectContactFor.value == "5") ? noOfUnit : ""
                },
                UnitsSection
                // "UnitsSection": [
                //     {
                //         "UnitNo": "1",
                //         "Floor": firstFloor ? firstFloor : "",
                //         "CarepetArea": carpetAreaOne ? carpetAreaOne : "",
                //         "EmployeeCount": empCountOne ? empCountOne : ""
                //     },
                //     {
                //         "UnitNo": "2",
                //         "Floor": secondFloor ? secondFloor : secondFloor,
                //         "CarepetArea": carpetAreaTwo ? carpetAreaTwo : "",
                //         "EmployeeCount": empCountTwo ? empCountTwo : ""
                //     },
                //     {
                //         "UnitNo": "3",
                //         "Floor": thirdFloor ? thirdFloor : "",
                //         "CarepetArea": carpetAreaThree ? carpetAreaThree : "",
                //         "EmployeeCount": empCountThree ? empCountThree : "",
                //     }
                // ],

            };



            // Send API request
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const result = await response.json();

            // if (opportunityData?.Product && (opportunityData?.otcDiscount || opportunityData?.rcDiscount)) {
            //     let updateProductreq = { productid: opportunityData.Product, discount: opportunityData.otcDiscount };
            //     let updateProduct = await api.updateOppProduct(updateProductreq)
            // }

            if (result?.Status === "Success") {

                toast.success("Opportunity updated successfully!", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                navigate("/businessOpportunityProWifi");
                // setTimeout(() => {
                //     window.location.reload()
                // }, 1500);
            } else {
                toast.warning("Failed to update opportunity!", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                return
            }

            // const updateSurvey = await api.updateopportunityWiFi(opportunitySurveyData)
            // console.log(updateSurvey);


        } catch (error) {
            console.error("Error updating opportunity:", error);
            // toast.error("Error updating opportunity.");
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        const fetchData = async () => {
            const getrelationship = await api.getRelationship(selectedCompany?.value)

            // console.log(getrelationship?.Response);

            if (!Array.isArray(getrelationship?.Response)) { return }

            setRelationOptions(getrelationship?.Response?.map((relationship) => (
                {
                    value: relationship.Relationship_ID,
                    label: relationship.Relationship_Name,
                }
            )));



        }

        fetchData()

    }, [selectedCompany]);

    useEffect(() => {
        const getCompanyGrouplist = async () => {
            const getCompany = await api.getCompanyGroup("New Company")
            const oppProduct = await api.getOppProduct({ oppid: OppId });
            // console.log(oppProduct);
            // console.log(oppProduct.Response?.Data);

            let relProductRC = oppProduct?.Response?.Data?.filter((data) => data.ProductId.includes("-RC"))
            let relProductOTC = oppProduct?.Response?.Data?.filter((data) => data.ProductId.includes("-OTC"))

            // console.log(relProductRC, relProductOTC);
            setRCProd(relProductRC)
            setOTCProd(relProductOTC)


            setRelatedProductOptions(oppProduct?.Response?.Data?.map((data) => (
                {
                    value: data.ProductId,
                    label: data.ProductId
                    ,
                }
            )))

            // selectedRelatedProduct()
            // relatedProductOptions()

            setGroupOptions(getCompany?.Response?.Data?.map((data) => (
                {
                    value: data.Group_ID,
                    label: data.Group_Name,
                }
            )))

            setCompanyOptions(getCompany.Response.Data?.map((data) => (
                {
                    value: data.Company_ID,
                    label: data.Company_Name,
                }
            )))
        };

        getCompanyGrouplist()

    }, []);

    useEffect(() => {
        const fetchGetIndustry = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestData = {
                    Action: "getindustrytype",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    areaCode: "",
                    areaName: "",
                    password: sessionStorage.getItem("password"),
                    userName: sessionStorage.getItem("userName"),
                };

                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                });

                const result = await response.json();
                if (result.Status == "Success") {
                    const industryType = result.Response.map(
                        (option) => ({
                            label: option.IndTypeName,
                            value: option.IndTypeId,
                        })
                    );
                    const updatedtransformedOptions = industryType.filter(item => !['IND_0073_ID', 'IND_0072_ID', 'IND_0074_ID', 'IND_0068_ID'].includes(item.value));
                    setindustrydropdetails(updatedtransformedOptions);
                }
            } catch (error) {
                console.error("Error fetching data:", error.message);
            } finally {

            }
        };

        fetchGetIndustry();
    }, []);



    useEffect(() => {
        const fetchData = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL;
                const payload = {
                    Action: "getPricelist",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    buildingname: selectSociety ? selectSociety : "",
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName')
                };
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                });

                const result = await response.json();

                if (result?.Status === "Success" && result?.Response?.Data) {

                    const priceList = result.Response.Data.map(
                        (option) => ({
                            label: option.PriceName,
                            value: option.PriceName,
                        })
                    );
                    setPriceListOptions(priceList);

                } else {
                    console.error("Failed to retrieve price list:", result);
                }
            } catch (error) {
                console.error("Error fetching price list:", error);
            }
        }; fetchData();
    }, [selectSociety]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL;
                const payload = {
                    Action: "getProductlist",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    oppid: OppId ? OppId : "",
                    reason: "",
                    siteId: "",
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName'),
                };

                // Send API request
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                });
                const result = await response.json();
                // console.log(result);

                if (result?.Status === "Success") {
                    // const productList = result.Response.Data.map(item => item.ProductId);
                    // console.log("result.Response.Data", result.Response.Data)
                    const productList = result.Response.Data.map(
                        (option) => ({
                            label: option.ProductId,
                            value: option.ProductId,
                        })
                    );
                    setProductOptions(productList);
                }
            } catch (error) {
                console.error("Error fetching product list:", error);
            }
        }; fetchData();
    }, []);

    const relatedProductChange = async (selectedOption) => {
        // console.log(selectedOption);
        // selectedOption.value.includes("-RC")
        setSelectedRelatedProduct(selectedOption);

        if (selectedOption.value.includes("-OTC")) {
            setDiscountFlag("OTC")
            // setOpportunityData((prevData) => ({
            //   ...prevData,
            //   otcDiscount: ""
            // }));
        } else if (selectedOption.value.includes("-RC")) {
            setDiscountFlag("RC")
            // setOpportunityData((prevData) => ({
            //   ...prevData,
            //   rcDiscount: ""
            // }));
        } else {
            setDiscountFlag()
        }
    }


    const handleProductChange = async (selectedOption) => {
        setSelectedProduct(selectedOption);
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestBody = {
                Action: "createOppProduct",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                oppid: OppId ? OppId : "",
                password: sessionStorage.getItem('password'),
                productid: selectedOption.value,
                userName: sessionStorage.getItem('userName'),
            };
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });

            const responsedata = await response.json();

            if (responsedata.Status == "Failure") {
                toast.warning(responsedata.Response.Message.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }

        } catch (error) {
            // Handle fetch error
            console.error("Error fetching data:", error);
        }
    };

    const redirectoppPage = () => {
        Swal.fire({
            html: '<div style="font-size: 15px;">Do you want to go back to the previous screen?</div>',
            showCancelButton: true,
            confirmButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">YES</span>',
            cancelButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            customClass: {
                popup: "custom-popup",
                confirmButton: "custom-confirm-button",
                cancelButton: "custom-cancel-button",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                navigate("/businessOpportunityProWifi");
            }
        });
    };



    const fetchCompanyData = async () => {
        try {
            setLoader(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestBody = {
                Action: "getCompany",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                companyId: "New Company",
                password: sessionStorage.getItem('password'),
                userName: sessionStorage.getItem('userName'),
            };

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });
            const data = await response.json();
            // console.log("conpany name :", data.Response.Data);
            if (data.Status === "Success" && data.StatusCode === "200") {
                return data.Response.Data.map((company) => ({
                    label: `${company.Company_Name} (${company.Company_ID})`,
                    value: company.Company_ID,
                    group: `${company.Group_Name} (${company.Group_ID})`,
                    groupId: company.Group_ID,
                }));
            } else {
                console.error("Error in API response:", data);
                return [];
            }
        } catch (error) {
            console.error("Error fetching company data:", error);
        } finally {
            setLoader(false);
        }
        return [];
    };

    useEffect(() => {
        const fetchCities = async () => {
            try {
                // City API call
                const cityApiUrl = process.env.REACT_APP_API_URL;
                const cityRequestBody = {
                    Action: "getCity",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    password: sessionStorage.getItem('password'),
                    stateCode: selectState.value,
                    userName: sessionStorage.getItem('userName'),
                };
                const cityResponse = await fetch(cityApiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(cityRequestBody),
                });
                const cityData = await cityResponse.json();

                if (cityData.Response && Array.isArray(cityData.Response.Data)) {
                    const filteredCities = cityData.Response.Data.filter(
                        (city) => city.IsOperationalCity === true
                    );
                    setCityType(filteredCities);
                } else {
                    // console.error(
                    //   "City data structure not recognized:",
                    //   cityData.Response
                    // );

                    setCityType([]);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        if (selectState) {
            fetchCities();
        }
    }, [selectState]);



    const handleSelectCity = async (selectedOption) => {
        const selectedCityCode = selectedOption ? selectedOption.value : "";
        const selectedCityName = selectedOption ? selectedOption.label : "";
        // console.log("selectedCityCode", selectedOption.value);
        // console.log("selectedCityName", selectedOption.label);
        setSelectCity(selectedOption);
        setSelectArea("");
        // setSelectBuilding("");
        try {
            const areaApiUrl = process.env.REACT_APP_API_URL;
            const areaRequestBody = {
                Action: "getArea",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                cityCode: selectedCityCode,
                cityName: selectedCityName,
                password: sessionStorage.getItem('password'),
                restrictedarea: false,
                stateCode: "",
                userName: sessionStorage.getItem('userName'),
            };
            const areaResponse = await fetch(areaApiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(areaRequestBody),
            });
            const areaData = await areaResponse.json();
            if (areaData.Response && Array.isArray(areaData.Response.Data)) {
                // console.log("area :", areaData.Response.Data);
                setAreaList(areaData.Response.Data);
            }
        } catch (error) {
            console.error("Error fetching area data:", error);
        }
    };

    const handleSelectArea = async (selectedOption) => {
        try {
            // console.log(selectedOption);

            setSelectArea(selectedOption);
            setSelectBuilding("");


            let payload = {
                areaCode: selectedOption.value,
                areaName: selectedOption.label.split(" ")[0]
            }
            let getBuilding = await api.getBuilding(payload);
            // console.log("getBuilding: ", getBuilding);

            if (getBuilding.Response && Array.isArray(getBuilding.Response.Data)) {
                setBuildingList(getBuilding.Response.Data);
            }
        } catch (error) {
            console.error("Error fetching building data:", error);
        }
    };

    // ================ MS-WIFI =======================

    const getWiredLANIntegrationOptions = wifiOptions.getWiredLANIntegrationOptions()
    const getBuildingAndFloorPlanOptions = wifiOptions.getBuildingAndFloorPlanOptions()
    const getNetworkSecurityRequiredOptions = wifiOptions.getNetworkSecurityRequiredOptions();
    const getExistingNetworkSecurityDeviceOptions = wifiOptions.getExistingNetworkSecurityDeviceOptions();
    const getSeparateNetworkForBackOfficeOptions = wifiOptions.getSeparateNetworkForBackOfficeOptions();
    const getBandwidthRequiredOptions = wifiOptions.getBandwidthRequiredOptions();
    const getExistingWiFiCablingByCustomerOptions = wifiOptions.getExistingWiFiCablingByCustomerOptions();
    const getAPIIntegrationRequiredOptions = wifiOptions.getAPIIntegrationRequiredOptions();
    const getPMSVendorForAPIIntegrationOptions = wifiOptions.getPMSVendorForAPIIntegrationOptions();
    const getAnyIOTDevicesToBeConnectedOptions = wifiOptions.getAnyIOTDevicesToBeConnectedOptions();
    const getCountOfExistingInternetLinksOptions = wifiOptions.getCountOfExistingInternetLinksOptions();
    const getTypeOfExistingInternetLinkOptions = wifiOptions.getTypeOfExistingInternetLinkOptions();
    const getUserTypeOptions = wifiOptions.getUserTypeOptions();
    const getSpeedPerUserOptions = wifiOptions.getSpeedPerUserOptions();
    const getLoginMechanismOptions = wifiOptions.getLoginMechanismOptions();
    const getPlanValidityDataVolumeCriteriaOptions = wifiOptions.getPlanValidityDataVolumeCriteriaOptions();
    const getBandwidthTypeOptions = wifiOptions.getBandwidthTypeOptions();
    const getTypeOfWiredLANSetupOptions = wifiOptions.getTypeOfWiredLANSetupOptions();
    const [selectedDropdownObj, setSelectedDropdownObj] = useState({})
    const [opportunitySurveyData, setOpportunitySurveyData] = useState({
        "Action": "updateopportunityWiFi",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "userName": sessionStorage.getItem('userName'),
        "password": sessionStorage.getItem('password')
    })

    const [getCreateGridData, setCreateGridData] = useState({
        "Action": "createUserlicenceGrid",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "userName": sessionStorage.getItem('userName'),
        "password": sessionStorage.getItem('password'),
    })
    const [oppWifiData, setOppWifiData] = useState({})

    const formInputData = (e) => {
        const { name, value, type } = e.target;
        // console.log(name, value);

        setOpportunitySurveyData((prevData) => ({
            ...prevData,
            [name]: type === "number" ? String(value) : value,
        }));

    };

    const formDropdownInput = (name, value) => {
        // console.log(name, value);
        // console.log("opportunitySurveyData", opportunitySurveyData);

        setOpportunitySurveyData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // const formDropdownInputGrid = (name, value) => {
    //   // const { name, value } = e.target;
    //   console.log(name, value);
    //   // console.log("opportunitySurveyData", getCreateGridData);

    //   setCreateGridData((prevData) => ({
    //     ...prevData,
    //     [name]: value,
    //   }));
    // };


    // const formInputGrid = (e) => {
    //   const { name, value } = e.target;
    //   // console.log(name, value);

    //   setCreateGridData((prevData) => ({
    //     ...prevData,
    //     [name]: value,
    //   }));
    // };

    useEffect(() => {
        async function fetchData() {
            try {
                const oppData = await api.getopportunityWiFi(OppId);
                if (oppData?.Status == "Success") {
                    const opportunityData = oppData?.Response?.oppDetails;
                    // console.log(opportunityData);

                    setOpportunitySurveyData((prevData) => ({
                        ...prevData,
                        "BuildingFloorAttachment": opportunityData?.BuildingFloorAttachment || "",
                        "OppId": OppId || "",
                        "SiteName": opportunityData?.SiteName || "",
                        "CustomerContactName": opportunityData?.CustomerContactName || "",
                        "CustomerContactNumber": opportunityData?.CustomerContactNumber || "",
                        "Customeremailidsitespoc": opportunityData?.Customeremailidsitespoc || "",
                        "ListofBuildings": opportunityData?.ListofBuildings || "",
                        "AreatobeCovered": opportunityData?.AreatobeCovered || "",
                        "BuildingandFloorPlan": opportunityData?.BuildingandFloorPlan || "",
                        "NetworkSecurityrequired": opportunityData?.NetworkSecurityrequired || "",
                        "Anyspecificsecurity": opportunityData?.Anyspecificsecurity || "",
                        "MakeModelofexisting": opportunityData?.MakeModelofexisting || "",
                        "ExistingNetworkSecurityDevice": opportunityData?.ExistingNetworkSecurityDevice || "",
                        "LinkTerminatingFloor": opportunityData?.LinkTerminatingFloor || "",
                        "BandwidthRequired": opportunityData?.BandwidthRequired || "",
                        "Countofexistinginternetlinks": opportunityData?.Countofexistinginternetlinks || "",
                        "ISPofexistinginternetLink1": opportunityData?.ISPofexistinginternetLink1 || "",
                        "TypeofexistinginternetLink1": opportunityData?.TypeofexistinginternetLink1 || "",
                        "BandwidthoFexistinginternetLinkMbps1": opportunityData?.BandwidthoFexistinginternetLinkMbps1 || "",
                        "ISPofexistinginternetLink2": opportunityData?.ISPofexistinginternetLink2 || "",
                        "TypeofexistinginternetLink2": opportunityData?.TypeofexistinginternetLink2 || "",
                        "BandwidthoFexistinginternetLinkMbps2": opportunityData?.BandwidthoFexistinginternetLinkMbps2 || "",
                        "BandwidthType": opportunityData?.BandwidthType || "",
                        "RequiredBandwidthinMbps": opportunityData?.RequiredBandwidthinMbps || "",
                        "WiredLANIntegration": opportunityData?.WiredLANIntegration || "",
                        "NoofwiredLANports": opportunityData?.NoofwiredLANports || "",
                        "TypeofWiredLANSetup": opportunityData?.TypeofWiredLANSetup || "",
                        "MakeModelLANswitches": opportunityData?.MakeModelLANswitches || "",
                        "ExistingWiFiCabling": opportunityData?.ExistingWiFiCabling || "",
                        "APIintegrationrequired": opportunityData?.APIintegrationrequired || "",
                        "PMSVendorforAPIIntegration": opportunityData?.PMSVendorforAPIIntegration || "",
                        "AnyIOTdevicestobeconnected": opportunityData?.AnyIOTdevicestobeconnected || "",
                        "Tentativecountofdevices": opportunityData?.Tentativecountofdevices || "",
                        "SeparatenetworkBackoffice": opportunityData?.SeparatenetworkBackoffice || "",
                        "SpecialRequest": opportunityData?.SpecialRequest || ""
                    }));

                    // setSelectedDropdownObj
                    const BuildingandFloorPlan = getBuildingAndFloorPlanOptions



                } else {
                    throw new Error("getopportunityWiFi API Failure.");
                }
            } catch (err) {
                console.error(err);
            }
        }
        fetchData();
    }, []);


    const handleUserLicenceGrid = async () => {
        // console.log("rtyu");

        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestData = {
                "Action": "createUserlicenceGrid",
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "userName": sessionStorage.getItem('userName'),
                "password": sessionStorage.getItem('password'),
                "OppId": OppId ? OppId : "",
                "UserType": userType.value ? userType.value : "",
                "NoofUserLicensesrequired": opportunityData.noUserLicences ? opportunityData.noUserLicences : "",
                "SpeedPerUser": speedPerUser.value ? speedPerUser.value : "",
                "PlanValidityDataVolumeCriteria": planValidity.value ? planValidity.value : "",
                "DataVolumeinGB": opportunityData.dataValume ? opportunityData.dataValume : "",
                "DevicesperUser": opportunityData.devicesPerUser ? opportunityData.devicesPerUser : "",
                "LoginMechanism": loginMechanism.value ? loginMechanism.value : ""
            }
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });

            const data = await response.json();
            if (data.Response.StatusCode == 200) {
                toast.success(data.Response.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }

        } catch (error) {
            console.error(error);
            toast.error("An error occurred. Please try again later.", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
    }

    const handleUserType = (selectedState) => {
        setUserType(selectedState);
    };

    const handleSpeedPerUser = (selectedState) => {
        setSpeedPerUser(selectedState);
    };

    const handlePlanValidity = (selectedState) => {
        setPlanValidity(selectedState);
    };

    const handleLoginMechanism = (selectedState) => {
        setLoginMechanism(selectedState);
    };




    return (
        <>
            {/* ***********Header********* */}
            <div className="container-fluid text-light Header-style header">
                <div className="p-3">
                    <span
                        className=""
                        style={{ cursor: "pointer" }}
                        onClick={redirectoppPage}
                    >
                        <i className="fa-solid fa-arrow-left-long"></i>
                    </span>
                    <span className="p-1" >Update Opportunity Office</span>
                    {opportunityData.Status.toLowerCase() == "won" && (
                        <span className=" flr-createCAf" onClick={handleCreateCaf} style={{ fontSize: "10px" }}>
                            Create CAF
                        </span>
                    )}



                </div>
            </div>

            {/* ************Header end************ */}

            {loading ? (
                <div className="loader-wrapper">
                    <div className="loader">
                        <img src={load} alt="loading...."></img>
                    </div>
                </div>
            ) : (
                <form>

                    <div className="container-fluid mb-4 form-container">
                        {meetingcounter !== "" && Number(meetingcounter) >= 1 && (
                            <>
                                {(opportunityData.Status !== "Won" && opportunityData.Status !== "Lost") && (


                                    <div

                                    >
                                        {!showForm ? (
                                            <button
                                                type="button"
                                                className="btn btn-dark w-100 mt-2 btn text-light"
                                                onClick={() => setShowForm(true)}
                                            >
                                                Lost
                                            </button>
                                        ) : (
                                            <>
                                                <Select
                                                    isMulti
                                                    options={optionLost}
                                                    value={selectedReasons}
                                                    onChange={handleChanged}
                                                    styles={customStyles}
                                                    components={{ MultiValueRemove }}
                                                    className="basic-multi-select disqualify-select"
                                                    classNamePrefix="select"
                                                    placeholder="Select Lost Reason(s)..."
                                                    isSearchable={false}
                                                />
                                                <div className="d-flex justify-content-center gap-2 mt-3 mb-2">
                                                    <button
                                                        type="button"
                                                        className="btn text-light bg-dark rounded-pill submit-btn"
                                                        onClick={handleLost}
                                                        disabled={!selectedReasons.length}
                                                    >
                                                        Lost
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn text-light bg-dark rounded-pill submit-btn"
                                                        onClick={() => setShowForm(false)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>

                                            </>
                                        )}
                                    </div>

                                )}

                                {(opportunityData?.Status !== "Won" && opportunityData?.Status !== "Lost" && opportunityData?.QuoteStatus == "2") && (
                                    <div>
                                        <button
                                            type='button'
                                            className="btn w-100 mt-2 qualify-btn text-light"
                                            onClick={handleWon}
                                        >
                                            WON
                                        </button>
                                    </div>
                                )}

                            </>
                        )}

                        {(getRcDiscount && getRcDiscount > 0 && getOtcDiscount && getOtcDiscount > 0 && opportunityData?.Statuscode !== "Waiting for Approval" && opportunityData?.Statuscode !== "Approved" && opportunityData?.Statuscode !== "Won") && (
                            <>
                                {!(parseFloat(opportunityData?.OTCAmount) <= parseFloat(getOtcDiscount) ||
                                    parseFloat(opportunityData?.RCAmount) <= parseFloat(getRcDiscount)) && (
                                        <button
                                            type="button"
                                            className="btn w-100 mt-2 qualify-btn text-light"
                                            onClick={handleSendToApproval}
                                        >
                                            Submit for Approval
                                        </button>
                                    )}
                            </>
                        )}

                        {/* **************Opportunity Details toggle******************* */}
                        <div className="contact-toggle mt-3" onClick={() => handleIconClick("form1")}
                        >
                            <span className="toggle-text">Opportunity Details</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>

                        {activeForm === "form1" && (
                            <div className="container shadow  mb-3 bg-body rounded mt-4" id="form1">
                                <fieldset className="contact-form p-2">



                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Opportunity ID"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="Opportunity"
                                            name="OppId"
                                            value={opportunityData.OppId || ""}
                                            onChange={handleChange}
                                            disabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                        />
                                        <label htmlFor="Opportunity" className='mt-2'>Opportunity ID*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Opportunity ID"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="Opportunity"
                                            name="OppId"
                                            value={opportunityData.OppStatus || ""}
                                            onChange={handleChange}
                                            disabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                        />
                                        <label htmlFor="Opportunity" className='mt-2'>Opportunity Status*</label>
                                    </div>


                                    <div className="">
                                        <label className="select-search-label mt-1">Company*</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="company"
                                            value={selectedCompany}
                                            onChange={handleCompanyChange}
                                            // options={companyOptions}
                                            styles={style}
                                            isSearchable={true}
                                            isLoading={loader}
                                            placeholder="Select Company"
                                            // isDisabled={true}
                                            isDisabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                        />
                                    </div>

                                    <div className="">
                                        <label className="select-search-label mt-1" htmlFor="floatingSelect"> Group* </label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            id="group"
                                            name="group"

                                            isDisabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                            value={selectGroup}
                                            onChange={handleSelectGroup}
                                            // options={groupOptions}
                                            styles={style}
                                            placeholder="Select Group"
                                            isSearchable={true}
                                            isLoading={loader}
                                        />
                                    </div>

                                    <div className="">
                                        <label className="select-search-label mt-1" htmlFor="floatingSelect" > Relationship* </label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            // options={relationshipOptions}
                                            placeholder="Select Relationship"
                                            value={selectRelationship}
                                            onChange={handleSelectRelationship}
                                            styles={style}
                                            isDisabled={true}
                                            isLoading={loader}

                                        />

                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Lead Name"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="leadname"
                                            name="leadname"
                                            value={opportunityData.leadname || ""}
                                            onChange={handleChange}
                                            readOnly
                                            style={{ backgroundColor: 'transparent' }}
                                        />
                                        <label htmlFor="leadname" className='mt-2'>Lead Name*</label>
                                    </div>



                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-1"
                                            id="Leadid"
                                            name="Leadid"
                                            value={opportunityData.LeadId || ""}
                                            // onChange={handleChange}
                                            readOnly
                                            style={{ backgroundColor: 'transparent' }}
                                        />
                                        <label htmlFor="floatingInput" className='mt-2'>Lead ID*</label>
                                    </div>



                                </fieldset>
                            </div>
                        )}
                        {/* **************Contact Person Details toggle******************* */}
                        <div className="Lead-Channel-toggle mt-3" onClick={() => handleIconClick("form2")}
                        >
                            <span className="toggle-text">Contact Person Details</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>

                        {activeForm === "form2" && (
                            <div className="container shadow mb-3 bg-body rounded mt-4" id="form2">
                                <fieldset className="Lead-Channel-form p-2">

                                    <div className="">
                                        <label className="select-search-label mt-1">
                                            Salutation*
                                        </label>
                                        <Select
                                            className=" basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="Salutation"
                                            placeholder="Select Salutation"
                                            styles={style}
                                            value={selectSolutaton}
                                            isSearchable={false}
                                            onChange={handleSelectSolutation}
                                            options={optionSolutation.map((data) => ({
                                                value: data.value,
                                                label: data.label,
                                            }))}
                                            isDisabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                        />
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Contact Person Name"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="contactPerson"
                                            name="ContactPerson"
                                            value={opportunityData.ContactPerson || ""}
                                            onChange={handleChange}
                                            disabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                        />
                                        <label htmlFor="contactPerson" className='mt-2'>Contact Person Name*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Email"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="contactEmail"
                                            name="Emailaddress"
                                            value={opportunityData.Emailaddress || ""}
                                            onChange={handleChange}
                                            disabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                        />
                                        <label htmlFor="contactEmail" className='mt-2'>Email*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Mobile Number"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="contactMobile"
                                            name="Mobilephone"
                                            value={opportunityData.Mobilephone || ""}
                                            onChange={handleChange}
                                            disabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                        />
                                        <label htmlFor="contactMobile" className='mt-2'>Mobile Number*</label>
                                    </div>

                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Contact Designation</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="contactDesignation"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectContactDesignation}
                                            isSearchable={false}
                                            onChange={handleSelectContactDesignation}
                                            isDisabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                            options={[
                                                // { value: "111260000", label: "Owner" },
                                                // { value: "111260001", label: "Manager" },
                                                // { value: "111260002", label: "CareTaker" },
                                                // { value: "111260003", label: "Other" },

                                                { label: "Select Option", value: "0" },
                                                { label: "Admin Manager", value: "111260004" },
                                                { label: "IT / Network Manager", value: "111260005" },
                                                { label: "Other", value: "111260003" },
                                            ]}
                                        />
                                    </div>

                                    {selectContactDesignation?.label == "Other" && (<div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Designation"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="DesignationOthers"
                                            name="DesignationOthers"
                                            value={opportunityData.DesignationOthers || ""}
                                            onChange={handleChange}
                                            disabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                        />
                                        <label htmlFor="company" className='mt-2'>Specific Designation*</label>
                                    </div>)}


                                    <div className="">
                                        <label className="select-search-label mt-1">Country*</label>
                                        <Select
                                            className=" basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="Country"
                                            placeholder="Select Country"
                                            styles={style}
                                            isSearchable={false}
                                            value={{ label: "India", value: "10001" }}
                                            onChange={handleSelectCountry}
                                            options={optionCountry.map((data) => ({
                                                value: data.value,
                                                label: data.label,
                                            }))}
                                            isDisabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                        />
                                    </div>

                                    <div className="">
                                        <label className="select-search-label mt-1">State*</label>
                                        <Select
                                            className=" basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="IndustrySeg"
                                            placeholder="Select State"
                                            isSearchable={false}
                                            styles={style}
                                            value={selectState}
                                            onChange={handleSelectState}
                                            options={optionState.map((data) => ({
                                                value: data.code,
                                                label: data.name,
                                            }))}
                                            isDisabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                        />
                                    </div>

                                    <div className="">
                                        <label className="select-search-label mt-1">City*</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="City"
                                            placeholder="Select City"
                                            isSearchable
                                            styles={style}
                                            // value={cityType.find(
                                            //   (city) => city.CityCode === selectCity.value
                                            // )}
                                            value={selectCity}
                                            onChange={handleSelectCity}
                                            options={cityType.map((data) => ({
                                                value: data.CityCode,
                                                label: data.CityName,
                                            }))}
                                        />
                                    </div>

                                    <div className="search-area" style={{ position: "relative" }}>
                                        <label className="select-search-label mt-1">Area*</label>
                                        <Select
                                            options={areaList.map((area) => ({
                                                value: area.AreaCode,
                                                label: `${area.AreaName} (${area.AreaCode})`,
                                            }))}
                                            className="form-control form-control-sm p-1 custom-select"
                                            placeholder="Search Area"
                                            isSearchable
                                            styles={style}
                                            value={selectArea}
                                            onChange={handleSelectArea}
                                        />
                                        <i
                                            className="fas fa-search text-secondary"
                                            style={{
                                                position: "absolute",
                                                right: "15px",
                                                top: "63%",
                                                transform: "translateY(-50%)",
                                            }}
                                        ></i>
                                    </div>


                                    <div className="search-area" style={{ position: "relative" }}>
                                        <label className="select-search-label mt-1">Building Name*</label>
                                        <Select
                                            options={buildingList.map((building) => ({
                                                value: building.BuildingCode,
                                                label: `${building.BuildingName} (${building.BuildingCode})`,
                                            }))}
                                            className="form-control form-control-sm p-1 custom-select"
                                            placeholder="Search Area"
                                            isSearchable
                                            styles={style}
                                            value={selectBuilding}
                                            onChange={(selectedOption) =>
                                                setSelectBuilding(selectedOption)
                                            }
                                        />
                                        <i
                                            className="fas fa-search text-secondary"
                                            style={{
                                                position: "absolute",
                                                right: "15px",
                                                top: "63%",
                                                transform: "translateY(-50%)",
                                            }}
                                        ></i>
                                    </div>


                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Building Number"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="buildingNum"
                                            name="BuildingNo"
                                            value={opportunityData.BuildingNo || ""}
                                            onChange={handleChange}
                                            disabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                        />
                                        <label htmlFor="buildingNum" className='mt-2'>Building No./Plot No.*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Block"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="block"
                                            name="Block"
                                            value={opportunityData.Block || ""}
                                            onChange={handleChange}
                                            disabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                        />
                                        <label htmlFor="block" className='mt-2'>Block*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Floor"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="floor"
                                            name="Floor"
                                            value={opportunityData.Floor || ""}
                                            onChange={handleChange}
                                            disabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                        />
                                        <label htmlFor="floor" className='mt-2'>Floor*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Pin Code"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="pin"
                                            name="PostalCode"
                                            value={opportunityData.PostalCode || ""}
                                            onChange={handleChange}
                                            disabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                        />
                                        <label htmlFor="pin" className='mt-2'>Pin*</label>
                                    </div>
                                </fieldset>
                            </div>
                        )}
                        {/* **************Company Details toggle******************* */}
                        <div className="Company-details-toggle mt-3" onClick={() => handleIconClick("form3")}
                        >
                            <span className="toggle-text">Company Details</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>

                        {activeForm === "form3" && (
                            <div className="container shadow mb-3 bg-body rounded mt-4" id="form3">
                                <fieldset className="Company-details-form p-2">
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Company Name"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="company"
                                            name="Companyname"
                                            value={opportunityData.Companyname || ""}
                                            onChange={handleChange}
                                            disabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                        />
                                        <label htmlFor="company" className='mt-2'>Company Name*</label>
                                    </div>

                                    <div className="">
                                        <label className="select-search-label mt-1">
                                            Industry Segment*
                                        </label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            placeholder="Select Option"
                                            id="IndustryType"
                                            name="IndustryType"
                                            styles={style}
                                            value={selectIndustry}
                                            // isDisabled={true}
                                            isDisabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                            onChange={handleIndustryChnage}
                                            options={industrydropdetails.map((data) => ({
                                                value: data.value,
                                                label: data.label,
                                            }))}

                                        />
                                    </div>

                                    <div className="">
                                        <label className="select-search-label">
                                            Firm Type*
                                        </label>
                                        <Select
                                            className=" basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="selectCustomerSeg"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectedFirmType}
                                            isSearchable={false}
                                            onChange={handleSelectFirmType}
                                            options={firmtype}
                                            isDisabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                        />
                                    </div>




                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-1"
                                            id="spectraRFS"
                                            name="spectraRFS"
                                            value={opportunityData.spectraRFS}
                                            onChange={handleChange}
                                            disabled
                                            style={{ background: "transparent" }}
                                        />
                                        <label htmlFor="spectraRFS" className="mt-2">Spectra RFS</label>
                                    </div>




                                    {/* Existing Internet Provider */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Existing Internet Provider</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="existingInternetProvider"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectExistingInternetProvider}
                                            isDisabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                            isSearchable={false}
                                            onChange={handleSelectExistingInternetProvider}
                                            options={[
                                                { value: "111260000", label: "Airtel" },
                                                { value: "111260001", label: "Jio" },
                                                { value: "111260002", label: "Tata" },
                                                { value: "111260003", label: "ACT" },
                                                { value: "111260004", label: "New Building" },
                                                { value: "111260005", label: "Others" },
                                            ]}
                                        />
                                    </div>

                                    {selectExistingInternetProvider?.value == "111260005" &&
                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder=""
                                                className="form-control input-text form-control-sm mt-1"
                                                id="ExistingInternetProviderOther"
                                                name="ExistingInternetProviderOther"
                                                disabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                                value={opportunityData.ExistingInternetProviderOther}
                                                onChange={handleChange}
                                                style={{ background: "transparent" }}
                                            />
                                            <label htmlFor="pgInternetRatings" className="mt-2">Specific Existing Internet Provider</label>
                                        </div>}

                                    {/* Existing Internet Outflow Per Month */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Current Outflow Per Month</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="existingInternetOutflow"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectExistingInternetOutflow}
                                            isSearchable={false}
                                            onChange={handleSelectExistingInternetOutflow}
                                            isDisabled={opportunityData?.Status == "Won" || opportunityData?.Status == "Lost"}
                                            options={[
                                                { value: "111260000", label: "<5000" },
                                                { value: "111260001", label: "5001 - 10000" },
                                                { value: "111260008", label: "10001 - 20000" },
                                                { value: "111260009", label: ">20,000" },
                                                // { value: "111260002", label: "10001- 15000" },
                                                // { value: "111260003", label: "15001 - 20000" },
                                                // { value: "111260004", label: "20001 - 25000" },

                                                // { value: "111260005", label: ">25000" },
                                                { value: "111260006", label: "New Building" },
                                                { value: "111260007", label: "Others" },
                                            ]}
                                        />
                                    </div>

                                    {selectExistingInternetOutflow?.value == "111260007" &&
                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder=""
                                                className="form-control input-text form-control-sm mt-1"
                                                id="ExistingInternetOutflowPerMonthOther"
                                                name="ExistingInternetOutflowPerMonthOther"
                                                value={opportunityData.ExistingInternetOutflowPerMonthOther}
                                                onChange={handleChange}
                                                style={{ background: "transparent" }}
                                                disabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                            />
                                            <label htmlFor="pgInternetRatings" className="mt-2">Specific Current Outflow Per Month</label>
                                        </div>}



                                    {/* Pain Points - Multi-Select */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Pain Points</label>
                                        <Select
                                            className="basic-multi-select form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="painPoints"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectPainPoints}
                                            isMulti
                                            onChange={handleSelectPainPoints}
                                            options={painPointOptions}
                                            isDisabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                        />
                                    </div>



                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Payment Terms</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="paymentTerms"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectPayment}
                                            isSearchable={false}
                                            onChange={handleselectPayment}
                                            options={[
                                                { value: "111260001", label: "Agreed" },
                                                // { value: "111260002", label: "Not Agreed" }
                                            ]}
                                            isDisabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                        />
                                    </div>


                                    {/* ------ PR0-WiFi ------ */}
                                    <>



                                        {/* Barriers Dropdown */}
                                        <div className="select-container mt-2">
                                            <label className="select-search-label">Barriers*</label>
                                            <Select
                                                name="barriers"
                                                value={barriers}
                                                styles={style}
                                                onChange={setBarriers}
                                                options={barriersOptions}
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                isSearchable={false}
                                                isDisabled={true}

                                            />
                                        </div>

                                        {console.log("selectContactFor", selectContactFor.value)}



                                        {(selectContactFor.value == "2" || selectContactFor.value == "5") &&
                                            <div className="input-box form-floating" style={{ position: "relative", paddingTop: "5px" }}>
                                                <input
                                                    type="tel"
                                                    placeholder=""
                                                    className=" form-control input-text form-control-sm mt-1"
                                                    id="noOfUnit"
                                                    name="noOfUnit"
                                                    maxLength="5"
                                                    pattern="[0-9]{10}"
                                                    value={noOfUnit}
                                                    onChange={handleNoOfUnit}
                                                    style={{ backgroundColor: "transparent" }}
                                                    disabled
                                                />
                                                <i
                                                    className="fa-solid fa-minus text-secondary"
                                                    onClick={decrementUnit}
                                                    style={{
                                                        position: "absolute",
                                                        right: "50px",
                                                        top: "65%",
                                                        transform: "translateY(-50%)",
                                                        cursor: "pointer"
                                                    }}
                                                ></i>
                                                <i
                                                    className="fa-solid fa-plus text-secondary"
                                                    onClick={incrementUnit}
                                                    style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "65%",
                                                        transform: "translateY(-50%)",
                                                        cursor: "pointer"
                                                    }}
                                                ></i>
                                                <label htmlFor="floatingInput" className="m-0">
                                                    No. of Unit*
                                                </label>
                                            </div>
                                        }


                                        {noOfUnit >= 1 &&
                                            Array.from({ length: noOfUnit }, (_, index) => (
                                                <div className="border mt-2" key={index}>
                                                    <h6 className="p-2">Unit {index + 1}</h6>

                                                    {/* Floor Input */}
                                                    <div className="input-box form-floating">
                                                        <input
                                                            type="tel"
                                                            placeholder=""
                                                            className="form-control input-text form-control-sm mt-1"
                                                            id={`floor${index + 1}`}
                                                            name={`floor${index + 1}`}
                                                            // maxLength="3"
                                                            // pattern="[0-9]{10}"

                                                            min={1}
                                                            max={100}
                                                            value={
                                                                index === 0 ? firstFloor : index === 1 ? secondFloor : thirdFloor
                                                            }
                                                            // onChange={
                                                            //     index === 0
                                                            //         ? handleFirstFloor
                                                            //         : index === 1
                                                            //             ? handleSecondFloor
                                                            //             : handleThirdFloor
                                                            // }
                                                            onChange={(e) => {
                                                                let v = e.target.value.replace(/\D/g, ""); // keep only digits
                                                                // prevent leading zeros
                                                                v = v.replace(/^0+/, "");

                                                                if (v === "") {
                                                                    // allow clearing
                                                                    if (index === 0) setfirstFloor("");
                                                                    else if (index === 1) setSecondFloor("");
                                                                    else setThirdFloor("");
                                                                    return;
                                                                }

                                                                const num = parseInt(v, 10);

                                                                // ✅ Allow only 1–100
                                                                if (num >= 1 && num <= 100) {
                                                                    if (index === 0) setfirstFloor(num.toString());
                                                                    else if (index === 1) setSecondFloor(num.toString());
                                                                    else setThirdFloor(num.toString());
                                                                }
                                                                // ❌ If >100, just ignore new input
                                                            }}
                                                            // disabled={
                                                            //     index === 0
                                                            //         ? specialFloorOne.value !== ""
                                                            //         : index === 1
                                                            //             ? specialFloorTwo.value !== ""
                                                            //             : specialFloorThree.value !== ""
                                                            // }
                                                            disabled={
                                                                opportunityData.Status === "Won" || opportunityData.Status === "Lost"
                                                                    ? true
                                                                    : index === 0
                                                                        ? specialFloorOne.value !== ""
                                                                        : index === 1
                                                                            ? specialFloorTwo.value !== ""
                                                                            : specialFloorThree.value !== ""
                                                            }
                                                            onKeyDown={(e) => {
                                                                const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
                                                                const isDigit = /\d/.test(e.key);
                                                                if (!(isDigit || allowedKeys.includes(e.key))) {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                        <label htmlFor="floatingInput" className="mt-2">Floor</label>
                                                    </div>

                                                    {/* {(firstFloor || specialFloorOne) && (
                                                <span className="p-2" style={{ color: "red", fontSize: "15px" }}>
                                                    Select either a floor number or a special floor. Avoid duplicate entries.
                                                </span>
                                            )} */}

                                                    {index === 0 && (firstFloor || specialFloorOne) && (
                                                        <span className="" style={{ color: "#35a4e8", fontSize: "15px" }}>
                                                            Unit 1: Select either a floor number or a special floor. Avoid duplicate entries.
                                                        </span>
                                                    )}

                                                    {index === 1 && (secondFloor || specialFloorTwo) && (
                                                        <span className="" style={{ color: "#35a4e8", fontSize: "15px" }}>
                                                            Unit 2: Select either a floor number or a special floor. Avoid duplicate entries.
                                                        </span>
                                                    )}

                                                    {index === 2 && (thirdFloor || specialFloorThree) && (
                                                        <span className="" style={{ color: "#35a4e8", fontSize: "15px" }}>
                                                            Unit 3: Select either a floor number or a special floor. Avoid duplicate entries.
                                                        </span>
                                                    )}



                                                    <div className="select-container mt-2">
                                                        <label className="select-search-label mt-1">Special Floor</label>
                                                        <Select
                                                            className="basic-single form-control form-control-sm  p-1"
                                                            id={`specialFloor${index + 1}`}
                                                            name={`specialFloor${index + 1}`}
                                                            styles={style}
                                                            isSearchable={false}
                                                            // isDisabled={
                                                            //     index === 0
                                                            //         ? firstFloor !== ""
                                                            //         : index === 1
                                                            //             ? secondFloor !== ""
                                                            //             : thirdFloor !== ""
                                                            // }
                                                            isDisabled={
                                                                opportunityData.Status === "Won" || opportunityData.Status === "Lost"
                                                                    ? true
                                                                    : index === 0
                                                                        ? firstFloor !== ""
                                                                        : index === 1
                                                                            ? secondFloor !== ""
                                                                            : thirdFloor !== ""
                                                            }
                                                            value={
                                                                index === 0 ? specialFloorOne : index === 1 ? specialFloorTwo : specialFloorThree
                                                            }
                                                            onChange={
                                                                index === 0
                                                                    ? handleSpecialFloorOne
                                                                    : index === 1
                                                                        ? handleSpecialFloorTwo
                                                                        : handleSpecialFloorThree
                                                            }
                                                            options={optionSpecialFloor.map(data => ({
                                                                value: data.value,
                                                                label: data.label,
                                                            }))}

                                                        />
                                                    </div>





                                                    {/* Carpet Area */}
                                                    <div className="input-box form-floating">
                                                        <input
                                                            type="tel"
                                                            placeholder=""
                                                            className="form-control input-text form-control-sm mt-1"
                                                            id={`area${index + 1}`}
                                                            name={`area${index + 1}`}
                                                            maxLength="10"
                                                            pattern="[0-9]{10}"
                                                            disabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                                            value={
                                                                index === 0 ? carpetAreaOne : index === 1 ? carpetAreaTwo : carpetAreaThree
                                                            }
                                                            onChange={
                                                                index === 0
                                                                    ? handleCarpetAreaOne
                                                                    : index === 1
                                                                        ? handleCarpetAreaTwo
                                                                        : handleCarpetAreaThree
                                                            }
                                                            onKeyDown={(e) => {
                                                                const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
                                                                const isDigit = /\d/.test(e.key);
                                                                if (!(isDigit || allowedKeys.includes(e.key))) {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                        <label htmlFor="floatingInput" className="mt-2">Carpet Area</label>
                                                    </div>

                                                    {/* Employee Count */}
                                                    <div className="input-box form-floating">
                                                        <input
                                                            type="tel"
                                                            placeholder=""
                                                            className="form-control input-text form-control-sm mt-1"
                                                            id={`empCount${index + 1}`}
                                                            name={`empCount${index + 1}`}
                                                            disabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                                            maxLength="10"
                                                            pattern="[0-9]{10}"
                                                            value={
                                                                index === 0 ? empCountOne : index === 1 ? empCountTwo : empCountThree
                                                            }
                                                            onChange={
                                                                index === 0
                                                                    ? handleEmpCountOne
                                                                    : index === 1
                                                                        ? handleEmpCountTwo
                                                                        : handleEmpCountThree
                                                            }
                                                            onKeyDown={(e) => {
                                                                const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
                                                                const isDigit = /\d/.test(e.key);
                                                                if (!(isDigit || allowedKeys.includes(e.key))) {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                        <label htmlFor="floatingInput" className="mt-2">Employee Count</label>
                                                    </div>
                                                </div>
                                            ))}


                                        {/* <div className="select-container mt-2">
                                            <label className="select-search-label">Opportunity for</label>
                                            <Select
                                                name="selectContactFor"
                                                value={selectContactFor}
                                                styles={style}
                                                onChange={handleSelectContactFor}
                                                options={optionContactFor.map((data) => ({
                                                    value: data.value,
                                                    label: data.label,
                                                }))}
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                isSearchable={false}
                                                isDisabled={true}
                                                style={{ background: "transparent" }}
                                            />
                                        </div> */}




                                        <div className="input-box form-floating">
                                            <input
                                                type="tel"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm mt-1"
                                                id="totalCarpetArea"
                                                name="totalCarpetArea"
                                                maxLength="10"
                                                pattern="[0-9]{10}"
                                                value={totalCarpetArea}
                                                onChange={handleTotalCarpetArea}
                                                onBlur={handleEmpCountAndAreaBlur}
                                                // readOnly={Number(noOfUnit) > 1}

                                                readOnly={selectContactFor.value == "2" || opportunityData.Status == "Won" || opportunityData.Status == "Lost" || selectContactFor.value == "5"}
                                                onKeyDown={(e) => {
                                                    const allowedKeys = [
                                                        "Backspace",
                                                        "Delete",
                                                        "ArrowLeft",
                                                        "ArrowRight",
                                                        "Tab",
                                                    ];
                                                    const isDigit = /\d/.test(e.key);
                                                    if (
                                                        (isDigit || allowedKeys.includes(e.key))
                                                    ) {
                                                        return true;
                                                    } else {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                            <label htmlFor="floatingInput" className="mt-2">
                                                Total Carpet Area
                                            </label>
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="tel"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm mt-1"
                                                id="totalEmpCount"
                                                name="totalEmpCount"
                                                maxLength="10"
                                                pattern="[0-9]{10}"
                                                value={totalEmpCount}
                                                onBlur={handleEmpCountAndAreaBlur}
                                                onChange={handleTotalEmpCount}
                                                // readOnly={Number(noOfUnit) > 1}
                                                readOnly={selectContactFor.value == "2" || opportunityData.Status == "Won" || opportunityData.Status == "Lost" || selectContactFor.value == "5"}
                                                onKeyDown={(e) => {
                                                    const allowedKeys = [
                                                        "Backspace",
                                                        "Delete",
                                                        "ArrowLeft",
                                                        "ArrowRight",
                                                        "Tab",
                                                    ];
                                                    const isDigit = /\d/.test(e.key);
                                                    if (
                                                        (isDigit || allowedKeys.includes(e.key))

                                                    ) {
                                                        return true;
                                                    } else {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                            <label htmlFor="floatingInput" className="mt-2">
                                                Total Employee Count
                                            </label>
                                        </div>

                                        {/* <div className="">
                                            <label className="select-search-label mt-1">
                                                Access Point Count
                                            </label>
                                            <Select
                                                className=" basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="accessPointCount"
                                                placeholder="Select Option"
                                                styles={style}
                                                value={accessPointCount}
                                                isSearchable={false}
                                                onChange={handleSelectAccessPointCount}
                                                options={optionAccessPointCount.map((data) => ({
                                                    value: data.value,
                                                    label: data.label,
                                                }))}
                                            />
                                        </div>

                                        <div className="">
                                            <label className="select-search-label mt-1">
                                                Product Name
                                            </label>
                                            <Select
                                                className=" basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="ProductName"
                                                placeholder="Select Option"
                                                styles={style}
                                                value={productName}
                                                isSearchable={false}
                                                onChange={handleSelectProductName}
                                                options={optionProductName.map((data) => ({
                                                    value: data.value,
                                                    label: data.label,
                                                }))}
                                            />
                                        </div> */}

                                        <div className="">
                                            <label className="select-search-label mt-1">
                                                Static IP*
                                            </label>
                                            <Select
                                                className=" basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="staticIP"
                                                placeholder="Select Static IP"
                                                styles={style}
                                                isDisabled={true}
                                                value={selectDoesCustNeedStaticIP}
                                                isSearchable={true}
                                                onChange={handleSelectCustNeedStaticIP}
                                                options={optionStaticIp.map((data) => ({
                                                    value: data.value,
                                                    label: data.label,
                                                }))}
                                            />
                                        </div>

                                        {/* Applications Dropdown */}
                                        <div className="select-container mt-2">
                                            <label className="select-search-label">Applications*</label>
                                            <Select
                                                name="applications"
                                                value={applications}
                                                styles={style}
                                                onChange={setApplications}
                                                options={applicationsOptions}
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                isSearchable={false}
                                                isDisabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                            />
                                        </div>


                                        {/* Company Turn over Dropdown */}
                                        <div className="select-container mt-2">
                                            <label className="select-search-label">Company Turnover*</label>
                                            <Select
                                                name="CompanyTurnover"
                                                value={companyTurnover}
                                                styles={style}
                                                onChange={setCompanyTurnover}
                                                options={companyTurnoverOptions}
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                isSearchable={false}
                                                isDisabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                                            />
                                        </div>

                                        <div className="input-box form-floating" style={{ position: "relative", paddingTop: "5px" }}>
                                            <input
                                                type="text"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm mt-1"
                                                id="latitude"
                                                name="latitude"
                                                value={opportunityData?.Latitude}
                                                // onChange={handleChange}
                                                style={{ background: "transparent" }}
                                                disabled
                                            />
                                            <i
                                                className="fa-solid fa-lock text-secondary"
                                                style={{
                                                    position: "absolute",
                                                    right: "20px",
                                                    top: "60%",
                                                    transform: "translateY(-50%)",
                                                }}
                                            ></i>
                                            <label htmlFor="floatingInput" className="m-0">Latitude*</label>
                                        </div>

                                        <div className="input-box form-floating" style={{ position: "relative", paddingTop: "5px" }}>
                                            <input
                                                type="text"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm mt-1"
                                                id="longitude"
                                                name="longitude"
                                                value={opportunityData?.Longitude}
                                                // onChange={handleChange}
                                                style={{ background: "transparent" }}
                                                disabled
                                            />
                                            <i
                                                className="fa-solid fa-lock text-secondary"
                                                style={{
                                                    position: "absolute",
                                                    right: "20px",
                                                    top: "60%",
                                                    transform: "translateY(-50%)",
                                                }}
                                            ></i>
                                            <label htmlFor="floatingInput" className="m-0">Longitude*</label>
                                        </div>

                                    </>


                                </fieldset>
                            </div>
                        )}








                        <div className="Remarks-toggle mt-3" onClick={redirectPriceCalPage}>
                            <span className="toggle-text">Plan Selector</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>

                        <div className="Remarks-toggle mt-3" onClick={() => handleIconClick("form13")}
                        >
                            <span className="toggle-text">Proposal Details</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>


                        {activeForm === "form13" && (
                            <div className="container shadow mb-3 bg-body rounded mt-4" id="form13">
                                <fieldset className="Remarks-form p-2">
                                    <div className="Other-details-toggle mt-3">

                                        <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                                            {allPraposalData?.length > 0 ? (
                                                allPraposalData.map((data, index) => (
                                                    <div className="col" key={index}>
                                                        <div className="card mb-3">
                                                            <div className="m-3 card-data" style={{ display: "inline-flex" }} >
                                                                <div>
                                                                    {/* <p className="caf-card-text">Opportunity Id : {data.OpportunityID}</p>
                                  <p className="caf-card-text" style={{ textWrap: "nowrap" }}> Document Name : {data.ProposalDocName}</p> */}
                                                                    <p className="caf-card-text">Created On : {data.ProposalCreatedOn}</p>

                                                                </div>
                                                            </div>
                                                            <div className="d-flex justify-content-center gap-2 p-2">
                                                                <button type="button" className="btn qualify-btn text-light w-50" onClick={() => handleDownload(data)}>
                                                                    Download
                                                                </button>

                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="col-12 text-center">
                                                    <p>No data available.</p>
                                                </div>
                                            )}
                                        </div>



                                    </div>
                                </fieldset>
                            </div>
                        )}






                        <div className="Remarks-toggle mt-3" onClick={() => handleIconClick("form12")}
                        >
                            <span className="toggle-text">Quote Details</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>


                        {activeForm === "form12" && (
                            <div className="container shadow mb-3 bg-body rounded mt-4" id="form12">
                                <fieldset className="Remarks-form p-2">
                                    <div className="Other-details-toggle mt-3">

                                        <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                                            {allQuoteData && allQuoteData?.length > 0 ? (
                                                allQuoteData.map((data, index) => (
                                                    <div className="col" key={index}>
                                                        <div className="card mb-3">
                                                            <div className="m-3 card-data" style={{ display: "inline-flex" }} >
                                                                <div>
                                                                    <p className="caf-card-text">Quote Id : {data.Quoteid}</p>
                                                                    <p className="caf-card-text">Total Amount : {data.TotalAmount}</p>
                                                                    <p className="caf-card-text">Opportunity Name : {data.OpportunityName}</p>
                                                                    <p className="caf-card-text">Status : {data.Status}</p>
                                                                    <p className="caf-card-text">Status Reason : {data.StatusReason}</p>
                                                                </div>
                                                            </div>
                                                            {meetingcounter !== "" && Number(meetingcounter) >= 1 && (
                                                                <>
                                                                    <div className="d-flex justify-content-center gap-2 p-2">
                                                                        <button type="button"
                                                                            className="btn qualify-btn text-light w-50"
                                                                            onClick={() => handleWonQoute(data.Quoteid)}
                                                                            disabled={proposalOptionType == "Both"}
                                                                        >
                                                                            Won
                                                                        </button>
                                                                        <button type="button" className="btn qualify-btn text-light w-50" onClick={() => handleLostQoute(data.Quoteid)}>
                                                                            Lost
                                                                        </button>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="col-12 text-center">
                                                    <p>No data available.</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </fieldset>
                            </div>)}


                        <div
                            className="Remarks-toggle mt-3"
                            onClick={() => handleIconClick("form6")}
                        >
                            <span className="toggle-text">Feasibilty</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>


                        {activeForm === "form6" && (
                            <div
                                className="container shadow mb-3 bg-body rounded mt-4"
                                id="form6"
                            >
                                <div className="input-box form-floating p-3 select-search-label">
                                    {getFeasibilityData?.length > 0 ? getFeasibilityData?.map((data, index) => (
                                        <div className="input-box form-floating p-2" key={index}>
                                            <strong className=''>Feasibility Id: {data?.FeasibilityId || ""}</strong>
                                            <div>Route Type: {data?.RouteType ? "Redundant Route" : "Primary Route"}</div>
                                            <div>Owner: {data?.Owner || "NA"}</div>
                                            <div>Feasibilty Status: <span style={{ color: data?.FeasibilityStatus === "0" ? "red" : data?.FeasibilityStatus === "1" ? "green" : "black" }}> {data?.FeasibilityStatus == '1' ? 'Feasible' : ''}</span></div>
                                            <div>ARC: {data?.Arc || "NA"}</div>
                                            <div>OTC: {data?.Otc || "NA"}</div>
                                            <div>ISP Name: {data?.IspName || "NA"}</div>
                                        </div>
                                    )) : <div>No Feasibility records found.</div>}
                                </div>
                            </div>)}


                        <div
                            className="Installation-toggle mt-3"
                            onClick={() => handleIconClick("form4")}
                        >
                            <span className="toggle-text">Remarks</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>

                        {activeForm === "form4" && (
                            <div
                                className=" container shadow  mb-3 bg-body rounded mt-4"
                                id="form4"
                            >
                                <form className="Remark-form p-2">

                                    {/* <div className="remark-area">
                                        <label htmlFor="floatingInput">Remarks</label>
                                        <textarea
                                            type="text"
                                            placeholder=""
                                            className=" form-control input-text form-control-sm textarea"
                                            id="remark"
                                            name="remark"
                                            value={opportunityData.remark}
                                            onChange={handleChange}
                                        />

                                    </div> */}
                                    <div className="remark-area">
                                        <label htmlFor="floatingInput">Remarks</label>
                                        <textarea
                                            type="text"
                                            placeholder=""
                                            className=" form-control input-text form-control-sm textarea"
                                            id="remark"
                                            name="remark"
                                            value={opportunityData.remark}
                                            onChange={handleChange}
                                        />
                                    </div>

                                </form>
                            </div>
                        )}




                        <div className=" text-center mt-5 mb-3">
                            <button
                                type="button"
                                className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                                onClick={handleUpdateOpportunity}
                                disabled={opportunityData.Status == "Won" || opportunityData.Status == "Lost"}
                            >
                                Update
                            </button>
                        </div>

                    </div>
                </form>
            )}
        </>
    );
};

export default BusinessProWifiOpp;
